window.ggT = window.ggT || function (s) { var t = window.GGG_T; return (t && t[s]) || s; };
(function(){
  var base = window.GGG_ASSET_BASE || '';
  window.GGG_assetUrl = function(file){
    if (!file || /^(?:https?:|data:|\/\/)/i.test(file)) return file;
    file = String(file).replace(/^\.\//, '').replace(/^extracted-images\//, '');
    return base + file;
  };
})();
var assetUrl = window.GGG_assetUrl;


/* Homepage performance V2: one first-paint gate and a bounded preparation queue. */
(function () {
  var root = document.getElementById('splitHero');
  if (!root) return;
  var desktop = window.matchMedia('(min-width: 701px)');
  var started = false;
  var resolveReady;
  var painted = new Promise(function (resolve) { resolveReady = resolve; });
  var slideJobs = {};
  var api = window.GGGHero = { version: 3, painted: painted, prepareDeck: function () {} };

  // Small, bounded timing labels make future DevTools recordings self-describing.
  api.mark = function (label) {
    var perf = window.performance;
    if (!perf || !perf.mark || !perf.clearMarks) return;
    var name = 'GGG V3: ' + label;
    perf.clearMarks(name);
    perf.mark(name);
  };
  api.mark('startup');

  function finish() {
    if (started) return;
    started = true;
    // Two rendering opportunities, then a task: decorative setup cannot run in
    // the same animation-frame callback that precedes the first hero paint.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.setTimeout(function () { api.mark('hero paint gate released'); resolveReady(); }, 0);
      });
    });
  }
  var primary = root.querySelector(desktop.matches ? '.ggg-not-chosen-img-left' : '.ggg-slide-art-img-left');
  function primaryReady() {
    if (primary && primary.decode) primary.decode().catch(function () {}).then(finish);
    else finish();
  }
  if (!primary || (primary.complete && primary.naturalWidth > 0)) primaryReady();
  else {
    primary.addEventListener('load', primaryReady, { once: true });
    primary.addEventListener('error', finish, { once: true });
  }

  api.idle = function (fn) {
    painted.then(function () {
      function run() {
        if (document.hidden) {
          document.addEventListener('visibilitychange', function visible() {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', visible);
            api.idle(fn);
          });
          return;
        }
        fn();
      }
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1800 });
      else window.setTimeout(run, 180);
    });
  };

  api.prepareArt = function (side, urgent) {
    if (!desktop.matches) return Promise.resolve();
    var slide = document.getElementById(side === 'left' ? 'slideOutLeft' : 'slideOutRight');
    var img = slide && slide.querySelector('.ggg-slide-art-img');
    if (!img) return Promise.resolve();
    if (urgent) img.setAttribute('fetchpriority', 'high');
    if (slideJobs[side]) return slideJobs[side];
    img.setAttribute('fetchpriority', urgent ? 'high' : 'low');
    // Install both sources before the fallback URL so picture chooses just the
    // appropriate desktop/tablet asset. Native mobile sources remain intact.
    slide.querySelectorAll('source[data-srcset]').forEach(function (source) {
      source.setAttribute('srcset', source.getAttribute('data-srcset'));
      source.removeAttribute('data-srcset');
    });
    if (!img.hasAttribute('data-src') && img.complete && !img.naturalWidth) img.src = img.src;
    if (img.hasAttribute('data-src')) {
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    }
    slide.classList.add('ggg-slide-art-loaded');
    slideJobs[side] = new Promise(function (resolve) {
      function done() {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        // A failed speculative request may be retried by the next interaction.
        if (!img.naturalWidth) { delete slideJobs[side]; resolve(); return; }
        var decode = img.decode ? img.decode() : Promise.resolve();
        decode.catch(function () {}).then(function () {
          slide.classList.add('ggg-slide-art-decoded');
          resolve();
        });
      }
      if (img.complete) window.setTimeout(done, 0);
      else { img.addEventListener('load', done); img.addEventListener('error', done); }
    });
    return slideJobs[side];
  };

  function warm() {
    var connection = window.navigator && window.navigator.connection;
    if (!desktop.matches || (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')))) return;
    api.idle(function () {
      if (!desktop.matches) return;
      api.prepareDeck('left');
      api.prepareArt('left', false).then(function () {
        api.idle(function () {
          if (!desktop.matches) return;
          api.prepareDeck('right');
          api.prepareArt('right', false);
        });
      });
    });
  }
  warm();
  desktop.addEventListener('change', warm);
})();


/* Homepage performance V1: freeze ambient CSS animations outside the viewport.
   Card cycling remains event-driven. Pausing preserves the floating phase. */
(function () {
  var home = document.getElementById('ggg-terror-tarot-homepage');
  if (!home) return;
  var targets = home.querySelectorAll('.slide-out, .wall-section, .final-section');
  function visibility() {
    home.toggleAttribute('data-ggg-page-hidden', document.hidden);
  }
  visibility();
  document.addEventListener('visibilitychange', visibility);
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('ggg-motion-visible', entry.isIntersecting);
      });
    }, { threshold: 0 });
    targets.forEach(function (target) { observer.observe(target); });
  } else {
    targets.forEach(function (target) { target.classList.add('ggg-motion-visible'); });
  }
})();


/* ===== V13 BELOW-FOLD INIT DEFERRAL HELPER =====
   Uses IntersectionObserver so expensive below-fold sections do not initialize
   during the first mobile page load. */
(function () {
  if (window.GGG_deferSectionInit) return;

  window.GGG_deferSectionInit = function (selector, init, options) {
    options = options || {};
    var started = false;
    var name = options.name || selector;
    var rootMargin = options.rootMargin || '300px 0px';

    function run(reason) {
      if (started) return;
      started = true;
      try {
        if (window.console && console.info) {
          console.info('[GGG deferred init]', name, reason || 'run');
        }
        init();
      } catch (error) {
        console.error('[GGG deferred init failed]', name, error);
      }
    }

    function setup() {
      var target = document.querySelector(selector);
      if (!target) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            run('intersection');
          });
        }, {
          root: null,
          rootMargin: rootMargin,
          threshold: 0
        });

        observer.observe(target);

        /*
          Do not force-run with a short timeout. If the user never reaches a
          below-fold section, that section should not compete with initial load.
          The fallback below is only for old browsers without IntersectionObserver.
        */
        return;
      }

      window.setTimeout(function () {
        run('fallback-timeout');
      }, options.fallbackDelay || 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup, { once: true });
    } else {
      setup();
    }
  };
})();



/* ===== extracted script block 1 ===== */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.tapestry-section .tap-edition-toggle:not(:disabled)').forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      var card = toggle.closest('.tap-card');
      if (!card || toggle.disabled || card.dataset.editionLocked === 'shadow' || card.classList.contains('is-fading')) return;

      var photo = card.querySelector('.tap-photo');
      var label = card.querySelector('.tap-toggle-label');
      var isShadow = !card.classList.contains('is-shadow');
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function swapEdition() {
        card.classList.toggle('is-shadow', isShadow);
        card.dataset.edition = isShadow ? 'shadow' : 'original';
        var productLink = card.querySelector('.tap-card-link');
        if (productLink) {
          var productUrl = isShadow ? productLink.dataset.shadowUrl : productLink.dataset.originalUrl;
          if (productUrl) productLink.setAttribute('href', productUrl);
        }


        if (photo) {
          var nextSrc = isShadow ? photo.dataset.shadowSrc : photo.dataset.originalSrc;
          var nextSrcset = isShadow ? photo.dataset.shadowSrcset : photo.dataset.originalSrcset;
          var nextAlt = isShadow ? photo.dataset.shadowAlt : photo.dataset.originalAlt;

          if (nextSrcset) {
            photo.setAttribute('srcset', nextSrcset);
          } else {
            photo.removeAttribute('srcset');
          }

          if (nextSrc) {
            photo.src = nextSrc;
          }

          if (nextAlt) {
            photo.alt = nextAlt;
          }
        }

        if (label) label.textContent = isShadow ? 'Shadow' : 'Original';
        toggle.setAttribute('aria-checked', isShadow ? 'true' : 'false');
      }

      if (!photo || prefersReducedMotion) {
        swapEdition();
        return;
      }

      card.classList.add('is-fading');

      window.setTimeout(function() {
        swapEdition();

        window.setTimeout(function() {
          card.classList.remove('is-fading');
        }, 35);
      }, 240);
    });
  });
});


/* ===== extracted script block 2 ===== */
/* V13 deferred: wallpaper carousel initializes only when the wallpaper section is near the viewport. */
window.GGG_initWallpaperCarousel = window.GGG_initWallpaperCarousel || function () {
(function () {
  var carousel = document.querySelector('.wp-carousel');
  if (!carousel) return;

  var phone = carousel.querySelector('.wp-phone');
  var track = carousel.querySelector('.wp-track');
  var slides = Array.prototype.slice.call(carousel.querySelectorAll('.wp-slide'));
  var prev = carousel.querySelector('.wp-prev');
  var next = carousel.querySelector('.wp-next');
  var counter = carousel.querySelector('.wp-counter');
  var nameLabel = carousel.querySelector('.wp-card-name');
  var progressFill = carousel.querySelector('.wp-progress-fill');
  var index = 0;
  var total = slides.length;
  var isDragging = false;
  var startX = 0;
  var dragDelta = 0;
  var phoneWidth = 1;


  function loadWallpaperSlide(slideIndex) {
    if (slideIndex < 0 || slideIndex >= total) return;

    var img = slides[slideIndex] && slides[slideIndex].querySelector('img[data-src]');
    if (!img) return;

    var nextSrc = img.getAttribute('data-src');
    if (!nextSrc) return;

    /* ask Shopify for the wallpaper at exactly the size the phone shows it (its width x the screen's pixel density), so the browser
       never has to shrink it: a big shrink inside the moving slider is what made the line art look speckled and jagged */
    var box = img.closest('.wp-phone') || img.parentNode, bw = (box && box.clientWidth) || 236, bh = (box && box.clientHeight) || 503;
    var need = Math.max(bw, bh * 0.45) * (window.devicePixelRatio || 1);   /* the art is 1440 x 3200 (0.45 wide per tall), shown cover-fit */
    var w = Math.min(1440, Math.max(120, Math.ceil(need / 4) * 4));
    nextSrc = /[?&]width=\d+/.test(nextSrc) ? nextSrc.replace(/([?&])width=\d+/, '$1width=' + w) : nextSrc + (nextSrc.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;

    img.src = nextSrc;
    img.removeAttribute('data-src');
    img.classList.add('is-loaded');
  }

  function loadWallpaperWindow() {
    loadWallpaperSlide(index);
    loadWallpaperSlide(index + 1);
    loadWallpaperSlide(index - 1);
  }

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function clamp(value) {
    return Math.max(0, Math.min(total - 1, value));
  }

  function setTransform(value) {
    track.style.transform = 'translateX(' + value + '%)';
  }

  function update(animate) {
    loadWallpaperWindow();
    if (!animate) track.classList.add('no-transition');
    setTransform(-(index * 100));
    counter.textContent = pad(index + 1) + ' / ' + total;
    nameLabel.textContent = slides[index].getAttribute('data-name') || '';
    progressFill.style.width = (((index + 1) / total) * 100) + '%';
    prev.disabled = index === 0;
    next.disabled = index === total - 1;
    if (!animate) {
      window.requestAnimationFrame(function () {
        track.classList.remove('no-transition');
      });
    }
  }

  function goTo(nextIndex, animate) {
    index = clamp(nextIndex);
    update(animate !== false);
  }

  prev.addEventListener('click', function () { goTo(index - 1); });
  next.addEventListener('click', function () { goTo(index + 1); });

  document.addEventListener('keydown', function (event) {
    var tag = event.target && event.target.tagName ? event.target.tagName.toLowerCase() : '';
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || event.target.isContentEditable) return;
    if (event.key === 'ArrowLeft') goTo(index - 1);
    if (event.key === 'ArrowRight') goTo(index + 1);
  });

  function liveDrag(delta) {
    var deltaPct = (delta / phoneWidth) * 100;
    setTransform(-(index * 100) + deltaPct);
  }

  function startDrag(event) {
    if (event.button !== undefined && event.button !== 0) return;
    isDragging = true;
    startX = event.clientX;
    dragDelta = 0;
    phoneWidth = phone.clientWidth || 1;
    phone.classList.add('is-dragging');
    track.classList.add('no-transition');
    if (phone.setPointerCapture) phone.setPointerCapture(event.pointerId);
  }

  function moveDrag(event) {
    if (!isDragging) return;
    dragDelta = event.clientX - startX;
    liveDrag(dragDelta);
  }

  function endDrag(event) {
    if (!isDragging) return;
    isDragging = false;
    phone.classList.remove('is-dragging');
    track.classList.remove('no-transition');
    if (phone.releasePointerCapture) {
      try { phone.releasePointerCapture(event.pointerId); } catch (error) {}
    }

    var threshold = phoneWidth * 0.18;
    if (dragDelta < -threshold && index < total - 1) index += 1;
    if (dragDelta > threshold && index > 0) index -= 1;
    dragDelta = 0;
    update(true);
  }

  phone.addEventListener('pointerdown', startDrag);
  phone.addEventListener('pointermove', moveDrag);
  phone.addEventListener('pointerup', endDrag);
  phone.addEventListener('pointercancel', endDrag);
  phone.addEventListener('pointerleave', endDrag);

  update(false);
})();
};

window.GGG_deferSectionInit('.wall-section', window.GGG_initWallpaperCarousel, {
  name: 'wallpaper carousel',
  rootMargin: '550px 0px',
  fallbackDelay: 3000
});


/* ===== extracted script block 3 ===== */
// Scroll reveal
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));


/* ===== extracted script block 4 ===== */
(function() {
  var hero = document.getElementById('splitHero');
  if (hero) hero.classList.remove('hover-left', 'hover-right');
})();


/* ===== extracted script block 5 ===== */
/* LCP/mobile performance patch:
   The optimized hero images are now rendered directly in Liquid. Do not inject the
   old image_07/image_08/image_09/image_10 assets here, because setting img.src in
   JavaScript starts extra network work and hurts PageSpeed. Also do not create
   full-panel .slide-out-link anchors. Only the CTA buttons should navigate. */
(function() {
  document.querySelectorAll(
    '#splitLeft > img.ggg-not-chosen-img,' +
    '#splitRight > img.ggg-not-chosen-img,' +
    '#slideOutLeft > img.ggg-slide-art-img,' +
    '#slideOutRight > img.ggg-slide-art-img,' +
    '#slideOutLeft > a.slide-out-link,' +
    '#slideOutRight > a.slide-out-link'
  ).forEach(function(node) {
    node.remove();
  });
})();


/* ===== extracted script block 6 ===== */
(function() {
  var hero = document.getElementById('splitHero');
  if (!hero) return;

  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 701px)') : null;
  var center = document.getElementById('splitCenter');
  var active = null;

  var sides = {
    left: {
      panel: document.getElementById('splitLeft'),
      slide: document.getElementById('slideOutLeft'),
      overlay: document.querySelector('.slide-out-left .so-overlay'),
      cards: document.querySelector('.slide-out-left .so-cards'),
      cta: document.querySelector('.slide-out-left .so-cta'),
      link: null,
      hoverClass: 'hover-left',
      otherClass: 'hover-right',
      prefix: '--ggg-left-activate',
      defaultX: 0.24,
      defaultY: 0.44,
      defaultRX: 0.22,
      defaultRY: 0.22,
      edge: 'left'
    },
    right: {
      panel: document.getElementById('splitRight'),
      slide: document.getElementById('slideOutRight'),
      overlay: document.querySelector('.slide-out-right .shadow-overlay'),
      cards: document.querySelector('.slide-out-right .shadow-cards'),
      cta: document.querySelector('.slide-out-right .shadow-cta'),
      link: null,
      hoverClass: 'hover-right',
      otherClass: 'hover-left',
      prefix: '--ggg-right-activate',
      defaultX: 0.66,
      defaultY: 0.44,
      defaultRX: 0.22,
      defaultRY: 0.22,
      edge: 'right'
    }
  };

  function isDesktop() {
    return !desktopQuery || desktopQuery.matches;
  }

  function loadSlideArt(side) {
    if (window.GGGHero) {
      window.GGGHero.prepareDeck(side);
      window.GGGHero.prepareArt(side, true);
    }
  }

  function syncPanelAccess() {
    ['left', 'right'].forEach(function (side) {
      var hidden = isDesktop() && active !== side;
      sides[side].slide.toggleAttribute('inert', hidden);
      sides[side].slide.setAttribute('aria-hidden', String(hidden));
    });
  }
  syncPanelAccess();

  function setState(side) {
    var nextSide = side || null;
    if (nextSide === active) { syncPanelAccess(); return; }
    active = nextSide;
    syncPanelAccess();
    window.GGGHero.mark('panel ' + (active || 'closed'));
    ['left', 'right'].forEach(function (side) {
      sides[side].panel.setAttribute('aria-expanded', String(active === side));
    });

    if (active) loadSlideArt(active);

    if (active === 'left') {
      hero.classList.add('hover-left');
      hero.classList.remove('hover-right');
    } else if (active === 'right') {
      hero.classList.add('hover-right');
      hero.classList.remove('hover-left');
    } else {
      hero.classList.remove('hover-left', 'hover-right');
    }
  }

  function pointInsideRect(rect, ev, pad) {
    if (!rect) return false;
    pad = pad || 0;
    return ev.clientX >= rect.left - pad &&
           ev.clientX <= rect.right + pad &&
           ev.clientY >= rect.top - pad &&
           ev.clientY <= rect.bottom + pad;
  }

  function pointInsideEl(el, ev, pad) {
    if (!el) return false;
    return pointInsideRect(el.getBoundingClientRect(), ev, pad);
  }

  var hitGeometry = null;
  function invalidateGeometry() { hitGeometry = null; }
  function measureHitGeometry() {
    if (hitGeometry) return hitGeometry;
    var rect = hero.getBoundingClientRect();
    var style = getComputedStyle(hero);
    function value(name, fallback, percent) {
      var raw = style.getPropertyValue(name).trim();
      var number = parseFloat(raw);
      return Number.isFinite(number) ? (percent && raw.endsWith('%') ? number / 100 : number) : fallback;
    }
    var measured = { hero: rect };
    ['left', 'right'].forEach(function (side) {
      var cfg = sides[side], panel = cfg.panel.getBoundingClientRect();
      var width = cfg.slide.offsetWidth;
      measured[side] = {
        panel: panel,
        x: panel.left + panel.width * value(cfg.prefix+'-x',cfg.defaultX,true) + value(cfg.prefix+'-offset-x',0,false),
        y: panel.top + panel.height * value(cfg.prefix+'-y',cfg.defaultY,true) + value(cfg.prefix+'-offset-y',0,false),
        rx: panel.width * value(cfg.prefix+'-rx',cfg.defaultRX,true),
        ry: panel.height * value(cfg.prefix+'-ry',cfg.defaultRY,true),
        finalRect: { left: side === 'left' ? rect.left : rect.right-width,
          right: side === 'left' ? rect.left+width : rect.right, top: rect.top, bottom: rect.bottom }
      };
    });
    hitGeometry = measured;
    return measured;
  }
  window.addEventListener('resize', invalidateGeometry, { passive: true });
  window.addEventListener('scroll', invalidateGeometry, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(invalidateGeometry).observe(hero);
  function activationHit(side, ev) {
    var data = measureHitGeometry()[side];
    if (!pointInsideRect(data.panel,ev,0) || data.rx <= 0 || data.ry <= 0) return false;
    var dx = (ev.clientX-data.x)/data.rx, dy = (ev.clientY-data.y)/data.ry;
    return dx*dx+dy*dy <= 1;
  }
  function finalSlideRect(side) { return measureHitGeometry()[side].finalRect; }

  function persistenceHit(side, ev) {
    var cfg = sides[side];
    if (!cfg) return false;

    /*
      Use geometry, not elementFromPoint. This is the important fix:
      the debug logs showed the browser could target the not-chosen image
      or even emit pointerleave while the cursor was still inside the hero
      or slide coverage. So we keep the slide open if the cursor is inside
      the active slide's FINAL coverage rectangle or any overlay/card/CTA box.
    */
    return pointInsideRect(finalSlideRect(side), ev, 8) ||
           pointInsideEl(cfg.overlay, ev, 24) ||
           pointInsideEl(cfg.cards, ev, 28) ||
           pointInsideEl(cfg.cta, ev, 28);
  }

  function clickActivationSide(ev) {
    if (!isDesktop() || !center) return null;

    var heroRect = hero.getBoundingClientRect();
    if (!pointInsideRect(heroRect, ev, 0)) return null;

    var centerRect = center.getBoundingClientRect();
    if (ev.clientX < centerRect.left) return 'left';
    if (ev.clientX > centerRect.right) return 'right';
    return null;
  }

  function onHeroClick(ev) {
    if (!isDesktop()) return;

    /*
      Let real links/buttons keep their normal behavior. This prevents a
      click on an already-open CTA from being swallowed or re-routed.
    */
    if (ev.target && ev.target.closest && ev.target.closest('a, button, .so-cards, .shadow-cards')) return;

    var side = clickActivationSide(ev);
    if (!side) return;

    setState(side);
  }

  function update(ev) {
    if (!isDesktop()) return;

    if (active && persistenceHit(active, ev)) {
      /*
        Re-apply the class on every valid move. If another legacy rule or
        browser target change briefly removes the class, the active state
        immediately restores it.
      */
      setState(active);
      return;
    }

    if (activationHit('left', ev)) {
      setState('left');
      return;
    }

    if (activationHit('right', ev)) {
      setState('right');
      return;
    }

    /*
      Only close on pointermove after the cursor is outside the active
      final coverage and outside both activation zones. Do not close from
      pointerleave, because pointerleave was firing even while inHero was true.
    */
    setState(null);
  }

  var pointerFrame = 0;
  var latestPointer = null;
  function schedulePointerUpdate(ev) {
    if (!isDesktop() || (ev.pointerType && ev.pointerType !== 'mouse' && ev.pointerType !== 'pen')) return;
    // Outside a closed hero there is no work to schedule.
    if (!active && !hero.contains(ev.target)) return;
    latestPointer = ev;
    if (pointerFrame) return;
    pointerFrame = window.requestAnimationFrame(function () {
      pointerFrame = 0;
      if (!document.hidden) update(latestPointer);
    });
  }
  document.addEventListener('pointermove', schedulePointerUpdate, { capture: true, passive: true });
  hero.addEventListener('click', onHeroClick, true);
  ['left', 'right'].forEach(function (side) {
    sides[side].panel.addEventListener('keydown', function (event) {
      if (!isDesktop() || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      setState(side);
      if (sides[side].cards.focus) sides[side].cards.focus({ preventScroll: true });
    });
  });
  hero.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !active) return;
    var previous = active;
    event.preventDefault();
    setState(null);
    if (sides[previous].panel.focus) sides[previous].panel.focus({ preventScroll: true });
  });


  /*
    Intentionally no pointerleave close handler.
    Closing on pointerleave was the bug: your debug log showed pointerleave
    fired while the cursor was still geometrically inside the hero/slide region.
    A normal pointermove outside the active zone will close it instead.
  */

  window.addEventListener('blur', function() {
    setState(null);
  });

  if (desktopQuery && desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function() {
      setState(null);
    });
  }

  setState(null);
})();

/* ===== extracted script block 7 ===== */
/* 23-card rotating floating stacks.
   Uses a hidden buffer card behind the stack so the next card is already loaded
   before it becomes visible. This prevents black frames and visible src swaps. */
(function () {
  var ANIMATION_DONE_MS = 640;
  var SEND_BEHIND_MS = 165;

  function stackCardVariantFile(file) {
    if (!file) return '';

    var cleanFile = String(file);
    var isMobile = window.matchMedia &&
      window.matchMedia('(max-width: 700px)').matches;

    /*
      The floating card stack renders small:
      - mobile uses 320w files
      - normal desktop uses 420w files
      - high-density desktop uses 543w files
    */
    var suffix = '-desktop-420w';

    if (isMobile) {
      suffix = '-mobile-240w';
    } else if (window.devicePixelRatio && window.devicePixelRatio >= 1.5) {
      suffix = '-retina-543w';
    }

    return cleanFile.replace(/\.webp(?:\?.*)?$/i, suffix + '.webp');
  }

  function stackCardSrc(file) {
    return file ? assetUrl(stackCardVariantFile(file)) : '';
  }

  function makeCard(name, file) {
    return {
      name: name,
      file: file || '',
      get src() {
        return stackCardSrc(file);
      }
    };
  }

  /*
    Your current uploaded JS only includes image files for the first 5 cards per edition.
    Fill in the blank filenames below as you add the remaining 18 images.

    Until then, missing cards safely fall back to the first available images,
    so the stack will keep working instead of breaking.
  */
  var originalCards = [
    makeCard('The Fool', '0-fool.webp'),
    makeCard('The Magician', '1-magician.webp'),
    makeCard('The High Priestess', '2-high-priestess.webp'),
    makeCard('The Empress', '3-empress.webp'),
    makeCard('The Emperor', '4-emperor.webp'),
    makeCard('The Hierophant', '5-hierophant.webp'),
    makeCard('The Lovers', '6-lovers.webp'),
    makeCard('The Chariot', '7-chariot.webp'),
    makeCard('Strength', '8-strength.webp'),
    makeCard('The Hermit', '9-hermit.webp'),
    makeCard('Wheel of Fortune', '10-wheel-of-fortune.webp'),
    makeCard('Justice', '11-justice.webp'),
    makeCard('The Hanged Man', '12-hanged-man.webp'),
    makeCard('Death', '13-death.webp'),
    makeCard('Temperance', '14-temperance.webp'),
    makeCard('The Devil', '15-devil.webp'),
    makeCard('The Tower', '16-tower.webp'),
    makeCard('The Star', '17-star.webp'),
    makeCard('The Moon', '18-moon.webp'),
    makeCard('The Sun', '19-sun.webp'),
    makeCard('Judgement', '20-judgement.webp'),
    makeCard('The World', '21-worlda.webp'),
    makeCard('Bonus Card', '21-worldb.webp')
  ];

  var shadowCards = [
    makeCard('The Fool', '0-fool-shadow.webp'),
    makeCard('The Magician', '1-magician-shadow.webp'),
    makeCard('The High Priestess', '2-high-priestess-shadow.webp'),
    makeCard('The Empress', '3-empress-shadow.webp'),
    makeCard('The Emperor', '4-emperor-shadow.webp'),
    makeCard('The Hierophant', '5-hierophant-shadow.webp'),
    makeCard('The Lovers', '6-lovers-shadow.webp'),
    makeCard('The Chariot', '7-chariot-shadow.webp'),
    makeCard('Strength', '8-strength-shadow.webp'),
    makeCard('The Hermit', '9-hermit-shadow.webp'),
    makeCard('Wheel of Fortune', '10-wheel-of-fortune-shadow.webp'),
    makeCard('Justice', '11-justice-shadow.webp'),
    makeCard('The Hanged Man', '12-hanged-man-shadow.webp'),
    makeCard('Death', '13-death-shadow.webp'),
    makeCard('Temperance', '14-temperance-shadow.webp'),
    makeCard('The Devil', '15-devil-shadow.webp'),
    makeCard('The Tower', '16-tower-shadow.webp'),
    makeCard('The Star', '17-star-shadow.webp'),
    makeCard('The Moon', '18-moon-shadow.webp'),
    makeCard('The Sun', '19-sun-shadow.webp'),
    makeCard('Judgement', '20-judgement-shadow.webp'),
    makeCard('The World', '21-worlda-shadow.webp'),
    makeCard('Bonus Card', '21-worldb-shadow.webp')
  ];

  function mod(value, length) {
    return ((value % length) + length) % length;
  }

  function px(value) {
    return Number.parseFloat(value) || 0;
  }

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function availableSources(deck) {
    return deck
      .map(function (item) { return item && item.src ? item.src : ''; })
      .filter(Boolean);
  }

  function sourceFor(deck, deckIndex) {
    var safeIndex = mod(deckIndex, deck.length);
    var item = deck[safeIndex];

    if (item && item.src) return item.src;

    var sources = availableSources(deck);
    if (!sources.length) return '';

    return sources[mod(safeIndex, sources.length)];
  }

  function cardNameFor(deck, deckIndex) {
    var item = deck[mod(deckIndex, deck.length)];
    return item && item.name ? item.name : '';
  }

  function ensureImage(card) {
    var img = card.querySelector('img.ggg-stack-art');

    if (!img) {
      img = document.createElement('img');
      img.className = 'ggg-stack-art';
      img.decoding = 'async';
      img.draggable = false;
      img.setAttribute('aria-hidden', 'true');
      card.appendChild(img);
    }

    card.classList.add('ggg-has-art');
    return img;
  }

  function setCardImage(card, deck, deckIndex) {
    var safeIndex = mod(deckIndex, deck.length);
    var src = sourceFor(deck, safeIndex);
    var name = cardNameFor(deck, safeIndex);
    var img = ensureImage(card);

    if (src && img.getAttribute('src') !== src) {
      img.src = src;
    }

    img.alt = name;
    card.setAttribute('data-card-name', name);
    card.setAttribute('data-deck-index', String(safeIndex));
  }

  function decodeCardImage(card) {
    var img = ensureImage(card);

    if (img.decode) {
      img.decode().catch(function () {});
    }
  }

  function readCardStyle(card) {
    var cs = window.getComputedStyle(card);
    return { left: cs.left, bottom: cs.bottom, width: cs.width, height: cs.height,
      transform: cs.transform, filter: cs.filter };
  }
  function setEndpointOffset(source, sourceStyle, targetStyle) {
    source.style.setProperty('--ggg-end-x', (px(targetStyle.left) - px(sourceStyle.left)) + 'px');
    source.style.setProperty('--ggg-end-y', (px(sourceStyle.bottom) - px(targetStyle.bottom)) + 'px');
  }

  function clearMotionClasses(cards) {
    cards.forEach(function (card) {
      if (!card) return;

      card.classList.remove(
        'ggg-card-send-back',
        'ggg-card-reveal-front',
        'ggg-card-mid-shift',
        'ggg-card-behind'
      );

      card.style.animation = '';
      card.style.transform = '';
      card.style.filter = '';
      card.style.removeProperty('z-index');
      card.style.removeProperty('--ggg-end-x');
      card.style.removeProperty('--ggg-end-y');
    });
  }

  function getBaseCardClass(slotPrefix) {
    return slotPrefix === 'so-c' ? 'so-card' : 'shadow-card';
  }

  function getSlots(stack, slotPrefix) {
    return {
      back: stack.querySelector('.' + slotPrefix + '1'),
      middle: stack.querySelector('.' + slotPrefix + '2'),
      front: stack.querySelector('.' + slotPrefix + '3'),
      buffer: stack.querySelector('.ggg-buffer-card[data-slot-prefix="' + slotPrefix + '"]')
    };
  }

  function syncBufferUnderBack(bufferCard, backSlot, measured) {
    if (!bufferCard || !backSlot) return;

    var values = measured || readCardStyle(backSlot);

    bufferCard.style.position = 'absolute';
    bufferCard.style.left = values.left;
    bufferCard.style.right = 'auto';
    bufferCard.style.top = 'auto';
    bufferCard.style.bottom = values.bottom;
    bufferCard.style.width = values.width;
    bufferCard.style.height = values.height;
    bufferCard.style.transform = values.transform;
    bufferCard.style.filter = values.filter;
    bufferCard.style.opacity = '1';
    bufferCard.style.pointerEvents = 'none';
    bufferCard.style.setProperty('z-index', '0', 'important');
    bufferCard.style.animation = 'none';
  }

  function ensureBufferCard(stack, slotPrefix) {
    var bufferCard = stack.querySelector('.ggg-buffer-card[data-slot-prefix="' + slotPrefix + '"]');

    if (bufferCard) return bufferCard;

    var baseClass = getBaseCardClass(slotPrefix);
    var backSlot = stack.querySelector('.' + slotPrefix + '1');

    bufferCard = document.createElement('div');
    bufferCard.className = baseClass + ' ggg-buffer-card';
    bufferCard.dataset.slotPrefix = slotPrefix;
    bufferCard.setAttribute('aria-hidden', 'true');

    if (backSlot && backSlot.parentNode) {
      backSlot.parentNode.insertBefore(bufferCard, backSlot);
    } else {
      stack.insertBefore(bufferCard, stack.firstChild);
    }

    return bufferCard;
  }

  function setBufferImage(stack, slotPrefix, deck, deckIndex) {
    var slots = getSlots(stack, slotPrefix);
    var bufferCard = slots.buffer || ensureBufferCard(stack, slotPrefix);

    setCardImage(bufferCard, deck, deckIndex);
    syncBufferUnderBack(bufferCard, slots.back);
    decodeCardImage(bufferCard);

    return bufferCard;
  }

  function convertCardToBuffer(card, stack, slotPrefix, deck, deckIndex) {
    if (!card) return null;

    var baseClass = getBaseCardClass(slotPrefix);

    card.classList.remove(
      slotPrefix + '1',
      slotPrefix + '2',
      slotPrefix + '3',
      'ggg-card-send-back',
      'ggg-card-reveal-front',
      'ggg-card-mid-shift',
      'ggg-card-behind'
    );

    card.classList.add(baseClass);
    card.classList.add('ggg-buffer-card');
    card.dataset.slotPrefix = slotPrefix;
    card.setAttribute('aria-hidden', 'true');

    card.style.pointerEvents = 'none';
    card.style.animation = 'none';
    card.style.setProperty('z-index', '0', 'important');

    var currentSlots = getSlots(stack, slotPrefix);
    syncBufferUnderBack(card, currentSlots.back);

    setCardImage(card, deck, deckIndex);
    decodeCardImage(card);

    return card;
  }

  function activateBufferAsBack(bufferCard, slotPrefix) {
    if (!bufferCard) return;

    bufferCard.classList.remove('ggg-buffer-card');
    bufferCard.removeAttribute('data-slot-prefix');
    bufferCard.removeAttribute('aria-hidden');

    bufferCard.classList.add(slotPrefix + '1');

    bufferCard.style.pointerEvents = '';
    bufferCard.style.animation = '';
    bufferCard.style.opacity = '';
    bufferCard.style.removeProperty('left');
    bufferCard.style.removeProperty('right');
    bufferCard.style.removeProperty('top');
    bufferCard.style.removeProperty('bottom');
    bufferCard.style.removeProperty('width');
    bufferCard.style.removeProperty('height');
    bufferCard.style.removeProperty('transform');
    bufferCard.style.removeProperty('filter');
    bufferCard.style.removeProperty('z-index');
  }

  function rotateSlotsWithBuffer(stack, slotPrefix, deck, nextBufferIndex, oldBack, oldMiddle, oldFront, oldBuffer) {
    /*
      No image swapping on visible cards.

      oldBuffer, already loaded under the stack, becomes new back.
      oldBack becomes new middle.
      oldMiddle becomes new front.
      oldFront becomes the next hidden buffer.
    */

    [oldBack, oldMiddle, oldFront].forEach(function (card) {
      if (!card) return;
      card.classList.remove(slotPrefix + '1', slotPrefix + '2', slotPrefix + '3');
    });

    activateBufferAsBack(oldBuffer, slotPrefix);

    if (oldBack) oldBack.classList.add(slotPrefix + '2');
    if (oldMiddle) oldMiddle.classList.add(slotPrefix + '3');

    clearMotionClasses([oldBack, oldMiddle, oldFront, oldBuffer]);

    convertCardToBuffer(oldFront, stack, slotPrefix, deck, nextBufferIndex);
  }

  function setupCyclingStack(options) {
    var stack = document.querySelector(options.stackSelector);
    if (!stack || stack.dataset.ggg23CardStackReady === '1') return;

    var initialSlots = getSlots(stack, options.slotPrefix);

    if (!initialSlots.back || !initialSlots.middle || !initialSlots.front) return;
    if (!options.deck || options.deck.length < 3) return;

    stack.dataset.ggg23CardStackReady = '1';

    var state = {
      startIndex: 0,
      busy: false,
      loading: false,
      queued: false,
      cancelImageWait: null,
      sendBehindTimer: null,
      finishTimer: null,
      finishRotation: null,
      generation: 0
    };

    function renderRestingStack() {
      var slots = getSlots(stack, options.slotPrefix);

      if (!slots.back || !slots.middle || !slots.front) return;

      /*
        Only the next three visible cards are shown:
        back   = current + 2
        middle = current + 1
        front  = current

        Buffer = current + 3, already hidden beneath the back card.
      */
      setCardImage(slots.back, options.deck, state.startIndex + 2);
      setCardImage(slots.middle, options.deck, state.startIndex + 1);
      setCardImage(slots.front, options.deck, state.startIndex);

      setBufferImage(stack, options.slotPrefix, options.deck, state.startIndex + 3);
    }

    // One extra image stays ahead of the four-card window. A tap does not
    // normally have to start downloading the buffer needed for the next tap.
    var aheadImage = new Image();
    aheadImage.decoding = 'async';
    aheadImage.fetchPriority = 'low';
    function preloadAhead() {
      var src = sourceFor(options.deck, state.startIndex + 4);
      if (src && aheadImage.getAttribute('src') !== src) aheadImage.src = src;
    }

    function showLoadState(loading, failed) {
      state.loading = loading;
      stack.setAttribute('aria-busy', loading ? 'true' : 'false');
      stack.dataset.gggLoadState = loading ? 'loading' : failed ? 'error' : 'ready';
      var hint = stack.querySelector('.card-preview__hint');
      if (hint) {
        hint.textContent = loading ? window.ggT('Loading cards...') : failed ? window.ggT('Tap to retry') : window.ggT('Tap to reveal');
        hint.setAttribute('aria-label', loading ? window.ggT('Loading cards') : failed ? window.ggT('Cards could not load. Tap to retry.') : window.ggT('Tap to reveal cards'));
      }
    }

    function waitForImages(images) {
      return new Promise(function (resolve) {
        var remaining = images.length, done = false, cleanups = [], timer;
        function finish(ok) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          cleanups.forEach(function (cleanup) { cleanup(); });
          if (state.cancelImageWait === cancel) state.cancelImageWait = null;
          resolve(ok);
        }
        function cancel() { finish(false); }
        state.cancelImageWait = cancel;
        timer = window.setTimeout(function () { finish(false); }, 6000);
        images.forEach(function (img) {
          if (done) return;
          var decoding = false;
          function failed() { finish(false); }
          function loaded() {
            if (done || decoding || !img.complete) return;
            if (!img.naturalWidth) { failed(); return; }
            decoding = true;
            var decoded;
            try { decoded = img.decode ? img.decode() : Promise.resolve(); }
            catch (error) { failed(); return; }
            Promise.resolve(decoded).then(function () {
              if (!done && --remaining === 0) finish(true);
            }, failed);
          }
          img.addEventListener('load', loaded);
          img.addEventListener('error', failed);
          cleanups.push(function () {
            img.removeEventListener('load', loaded);
            img.removeEventListener('error', failed);
          });
          if (img.complete && !img.naturalWidth) img.src = img.src;
          loaded();
        });
        if (!remaining) finish(true);
      });
    }

    var prepared = false;
    function prepare() {
      if (prepared) return;
      prepared = true;
      renderRestingStack();
      preloadAhead();
    }
    stack.gggPrepare = prepare;
    stack.addEventListener('pointerenter', prepare, { passive: true });
    stack.addEventListener('focusin', prepare);

    async function rotate() {
      if (state.busy) {
        // Keep one follow-up tap during motion; coalesce taps while loading.
        // This prevents both lost input and a long backlog of animations.
        if (!state.loading) state.queued = true;
        return;
      }
      prepare();
      state.busy = true;
      var generation = ++state.generation;

      var slots = getSlots(stack, options.slotPrefix);
      var backSlot = slots.back;
      var middleSlot = slots.middle;
      var frontSlot = slots.front;
      var bufferSlot = slots.buffer || ensureBufferCard(stack, options.slotPrefix);

      if (!backSlot || !middleSlot || !frontSlot || !bufferSlot) {
        state.busy = false;
        return;
      }

      // Never expose an unloaded card, but acknowledge the tap immediately.
      var images = [backSlot, middleSlot, frontSlot, bufferSlot].map(function (card) {
        return ensureImage(card);
      });
      var pending = images.filter(function (img) { return !img.complete || !img.naturalWidth; });
      if (pending.length) {
        showLoadState(true, false);
        var loaded = await waitForImages(pending);
        if (generation !== state.generation) return;
        showLoadState(false, !loaded);
        if (!loaded) { state.busy = false; state.queued = false; return; }
      }
      showLoadState(false, false);
      stack.dispatchEvent(new CustomEvent('ggg:card-reveal-start'));
      var geometry = [backSlot, middleSlot, frontSlot].map(readCardStyle);
      syncBufferUnderBack(bufferSlot, backSlot, geometry[0]);

      window.clearTimeout(state.sendBehindTimer);
      window.clearTimeout(state.finishTimer);

      if (prefersReducedMotion()) {
        state.startIndex = mod(state.startIndex + 1, options.deck.length);
        renderRestingStack();
        preloadAhead();
        state.busy = false;
        return;
      }

      setEndpointOffset(frontSlot, geometry[2], geometry[0]);
      setEndpointOffset(middleSlot, geometry[1], geometry[2]);
      setEndpointOffset(backSlot, geometry[0], geometry[1]);

      window.GGGHero.mark(options.slotPrefix + ' rotation start');
      frontSlot.classList.add('ggg-card-send-back');
      middleSlot.classList.add('ggg-card-reveal-front');
      backSlot.classList.add('ggg-card-mid-shift');

      /*
        Send the outgoing front behind early so it does not flash over the stack.
        It is no longer responsible for loading the next image.
      */
      state.sendBehindTimer = window.setTimeout(function () {
        frontSlot.classList.add('ggg-card-behind');
        frontSlot.style.setProperty('z-index', '-1', 'important');
      }, SEND_BEHIND_MS);

      state.finishRotation = function () {
        if (!state.finishRotation) return;
        state.finishRotation = null;
        window.GGGHero.mark(options.slotPrefix + ' rotation complete');
        window.clearTimeout(state.sendBehindTimer);
        window.clearTimeout(state.finishTimer);
        state.startIndex = mod(state.startIndex + 1, options.deck.length);

        /*
          After increment:
          visible cards should be:
          back   = startIndex + 2
          middle = startIndex + 1
          front  = startIndex
          buffer = startIndex + 3
        */
        rotateSlotsWithBuffer(
          stack,
          options.slotPrefix,
          options.deck,
          state.startIndex + 3,
          backSlot,
          middleSlot,
          frontSlot,
          bufferSlot
        );

        // Start the next bounded preload before accepting another rotation.
        preloadAhead();
        state.busy = false;
        var queued = state.queued;
        state.queued = false;
        if (queued) rotate();
      };
      state.finishTimer = window.setTimeout(state.finishRotation, ANIMATION_DONE_MS);
    }

    function settleRotation() {
      state.queued = false;
      if (state.finishRotation) state.finishRotation();
      else if (state.busy) {
        // Release image listeners and timers on interruption. Stale promises
        // cannot move a stack after its panel closes, resizes, or leaves view.
        state.generation++;
        if (state.cancelImageWait) state.cancelImageWait();
        state.busy = false;
      }
      showLoadState(false, false);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) settleRotation();
    });
    window.addEventListener('pagehide', settleRotation);
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', settleRotation);
    var hero = document.getElementById('splitHero');
    new MutationObserver(function () {
      var openClass = options.slotPrefix === 'so-c' ? 'hover-left' : 'hover-right';
      if (window.matchMedia('(min-width: 701px)').matches && !hero.classList.contains(openClass)) settleRotation();
    }).observe(hero, { attributes: true, attributeFilter: ['class'] });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) settleRotation();
      }, { threshold: 0 }).observe(stack);
    }

    if (window.matchMedia('(max-width: 700px)').matches) window.GGGHero.idle(prepare);

    // The three visible cards and one hidden buffer are the rolling preload window.
    // rotateSlotsWithBuffer loads only the next card; no timed full-deck download.

    stack.setAttribute('role', 'button');
    stack.setAttribute('tabindex', '0');
    stack.setAttribute('aria-label', options.label + window.ggT('. Click to cycle through the 23-card stack.'));

    /*
      Use only the stack-level handler. Slot classes rotate, and cards trade roles,
      so individual card listeners become unreliable over time.
    */
    stack.addEventListener('click', function (event) {
      event.stopPropagation();
      rotate();
    });

    stack.addEventListener('keydown', function (event) {
      // The nested hint is a native button; its click owns its keyboard action.
      if (event.target !== stack || event.repeat) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        rotate();
      }
    });

    window.addEventListener('resize', function () {
      settleRotation();
      var slots = getSlots(stack, options.slotPrefix);
      if (slots.buffer && slots.back) {
        syncBufferUnderBack(slots.buffer, slots.back);
      }
    }, { passive: true });

    window.addEventListener('orientationchange', function () {
      settleRotation();
      window.setTimeout(function () {
        var slots = getSlots(stack, options.slotPrefix);
        if (slots.buffer && slots.back) {
          syncBufferUnderBack(slots.buffer, slots.back);
        }
      }, 180);
    }, { passive: true });
  }

  window.GGGHero.prepareDeck = function (side) {
    var stack = document.querySelector(side === 'left' ? '.so-cards' : '.shadow-cards');
    if (stack && stack.gggPrepare) stack.gggPrepare();
  };

  function init() {
    setupCyclingStack({
      stackSelector: '.slide-out-left .so-cards',
      slotPrefix: 'so-c',
      deck: originalCards,
      label: window.ggT('Original Edition floating card stack')
    });

    setupCyclingStack({
      stackSelector: '.slide-out-right .shadow-cards',
      slotPrefix: 'shadow-c',
      deck: shadowCards,
      label: window.ggT('Shadow Edition floating card stack')
    });
  }

  window.matchMedia('(max-width: 700px)').addEventListener('change', function (event) {
    if (event.matches) { window.GGGHero.prepareDeck('left'); window.GGGHero.prepareDeck('right'); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/* GGG responsive floating stack image marker:
   Floating card stacks now choose mobile 240w, desktop 420w, or retina 543w
   image assets based on viewport/DPR. */
window.GGG_FLOATING_STACK_RESPONSIVE_IMAGES = '240-420-543-v3';

/* GGG combined performance marker:
   Includes responsive tapestry srcset toggle + bounded four-image deck preparation. */
window.GGG_COMBINED_TAPESTRY_STACK_FIX = 'v1';
window.GGG_CARD_REVEAL_INPUT_FIX = '2026-10-05';

/* ===== extracted script block 8 ===== */
(function() {
  const hero = document.getElementById('splitHero');
  const center = document.getElementById('splitCenter');
  const leftSlide = document.getElementById('slideOutLeft');
  const rightSlide = document.getElementById('slideOutRight');

  if (!hero || !center || !leftSlide || !rightSlide) return;

  const desktopQuery = window.matchMedia('(min-width: 901px)');
  let raf = null;

  function updateBanner() {
    raf = null;

    if (!desktopQuery.matches) {
      center.style.transform = '';
      return;
    }

    /*
      IMPORTANT:
      Use offsetLeft for the banner's base grid position. offsetLeft is not
      affected by CSS transform, so this avoids the feedback-loop bug caused by
      measuring getBoundingClientRect() after the banner had already moved.
    */
    const baseLeft = center.offsetLeft;
    const centerWidth = center.offsetWidth;
    const heroWidth = hero.clientWidth;
    const leftSlideWidth = leftSlide.offsetWidth;
    const rightSlideWidth = rightSlide.offsetWidth;

    let targetLeft = baseLeft;

    if (hero.classList.contains('hover-left')) {
      // Left slide covers 0 â†’ leftSlideWidth. Banner begins immediately after it.
      targetLeft = leftSlideWidth;
    } else if (hero.classList.contains('hover-right')) {
      // Right slide begins at heroWidth - rightSlideWidth. Banner ends at that edge.
      targetLeft = heroWidth - rightSlideWidth - centerWidth;
    }

    const delta = Math.round((targetLeft - baseLeft) * 1000) / 1000;
    var transform = `translateX(${delta}px)`;
    if (center.style.transform !== transform) center.style.transform = transform;
  }

  function scheduleUpdate() {
    if (raf !== null) return;
    raf = requestAnimationFrame(updateBanner);
  }

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(hero, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('load', scheduleUpdate);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', scheduleUpdate);
  }

  scheduleUpdate();
  if ('ResizeObserver' in window) {
    var bannerResize = new ResizeObserver(scheduleUpdate);
    [hero, center, leftSlide, rightSlide].forEach(function (element) { bannerResize.observe(element); });
  }
})();


/* Homepage performance V1: the atmosphere controller is the sole lighting owner.
   Removed the second document-wide pointer handler that competed with it. */

/* Homepage performance V2.1: retain V2 static stars and startup scheduling;
   restore V1 moving-particle rendering, glow, sizes and native easing exactly.
   Reuse a bounded pool and suspend it offscreen or in hidden tabs. */
(function () {
  var root = document.getElementById('splitHero');
  if (!root || !window.GGGHero) return;
  var panels = [document.getElementById('splitLeft'), document.getElementById('splitRight')];
  var shades = panels.map(function (panel) { return panel.querySelector('.ggg-panel-shade'); });
  var edgeGlows = panels.map(function (panel, index) {
    var glow = document.createElement('span');
    glow.className = 'ggg-panel-edge-glow ggg-panel-edge-glow-' + index;
    glow.setAttribute('aria-hidden', 'true');
    panel.appendChild(glow);
    return glow;
  });
  root.classList.add('ggg-v3-lighting');
  root.setAttribute('data-ggg-motion-version', '3');
  var desktop = window.matchMedia('(min-width: 701px)');
  var pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STAR_MAPS = [[[1.05,73.65,67.67,"255,255,255",0.62,66],[0.85,89.22,8.69,"255,255,255",0.92,66],[1.25,64.99,54.49,"255,255,255",0.86,66],[1.05,80.58,69.81,"255,255,255",0.8,66],[1.15,95.72,33.66,"255,255,255",0.56,66],[0.75,84.75,60.37,"255,255,255",0.56,66],[0.95,37.85,55.2,"255,255,255",0.92,66],[1.15,70.46,4.58,"245,160,58",0.92,70],[0.95,63.57,36.48,"255,255,255",0.68,66],[0.95,37.02,20.95,"255,255,255",0.68,66],[0.85,64.8,60.91,"255,255,255",0.68,66],[0.85,55.69,68.46,"255,255,255",0.62,66],[0.95,84.29,77.6,"255,255,255",0.8,66],[0.85,87.64,31.47,"255,255,255",0.86,66],[1.05,91.45,45.89,"255,255,255",0.86,66],[1.05,56.14,26.27,"255,255,255",0.74,66],[1.25,58.46,89.78,"255,255,255",0.62,66],[0.85,79.21,42.22,"255,255,255",0.56,66],[1.15,45.37,95.38,"255,255,255",0.5,66],[1.25,50.06,17.87,"245,160,58",0.92,70],[1.15,91.26,87.05,"255,255,255",0.62,66],[0.85,60.9,15.28,"255,255,255",0.62,66],[0.75,76.25,53.94,"255,255,255",0.62,66],[1.05,87.8,94.69,"255,255,255",0.68,66],[0.85,76.58,12.84,"255,255,255",0.86,66],[1.15,47.53,54.98,"255,255,255",0.5,66],[1.25,93.55,57.1,"255,255,255",0.68,66],[1.25,47.27,78.46,"255,255,255",0.74,66],[1.15,80.75,19.04,"255,255,255",0.8,66],[1.15,42.36,46.7,"255,255,255",0.8,66],[1.05,40.26,33.93,"255,255,255",0.8,66],[0.75,86.17,24.87,"255,255,255",0.86,66],[0.95,42.19,27.85,"255,255,255",0.56,66],[1.35,44.31,86.13,"245,160,58",0.92,70],[0.95,55.03,5.06,"255,255,255",0.86,66],[1.25,96.9,92.64,"255,255,255",0.68,66],[1.15,54.22,74.8,"255,255,255",0.86,66],[1.15,52.28,93.47,"255,255,255",0.92,66],[0.85,67.17,30.0,"255,255,255",0.74,66],[1.25,66.34,93.89,"255,255,255",0.5,66],[0.85,71.76,20.36,"255,255,255",0.8,66],[0.95,79.61,86.07,"255,255,255",0.5,66],[1.25,40.64,62.07,"255,255,255",0.56,66],[1.15,96.69,27.91,"255,255,255",0.5,66],[0.95,94.04,67.73,"255,255,255",0.68,66],[1.25,65.47,46.5,"255,255,255",0.68,66],[0.95,44.22,21.37,"255,255,255",0.8,66],[0.75,75.1,77.0,"255,255,255",0.92,66],[1.05,41.9,74.75,"255,255,255",0.56,66],[1.15,54.61,60.33,"245,160,58",0.92,70],[1.25,46.74,12.76,"255,255,255",0.56,66],[0.75,65.01,78.12,"255,255,255",0.68,66],[1.25,94.96,19.94,"255,255,255",0.86,66],[1.05,95.82,39.67,"255,255,255",0.56,66],[1.15,78.26,34.72,"255,255,255",0.62,66],[1.15,50.6,34.12,"255,255,255",0.92,66],[1.25,73.38,96.55,"255,255,255",0.5,66],[0.85,53.82,48.35,"255,255,255",0.92,66]],[[0.85,19.66,49.87,"255,255,255",0.5,66],[0.85,55.14,73.93,"255,255,255",0.5,66],[0.75,60.86,54.49,"255,255,255",0.74,66],[1.25,46.74,89.1,"255,255,255",0.92,66],[1.25,12.58,93.86,"255,255,255",0.62,66],[1.05,4.38,81.08,"255,255,255",0.5,66],[1.05,42.25,29.26,"255,255,255",0.74,66],[1.25,11.26,12.1,"245,160,58",0.92,70],[0.85,13.56,54.86,"255,255,255",0.68,66],[0.95,61.58,19.0,"255,255,255",0.56,66],[0.95,26.42,31.86,"255,255,255",0.86,66],[1.05,48.87,17.25,"255,255,255",0.56,66],[0.85,39.04,61.95,"255,255,255",0.86,66],[0.95,35.01,27.08,"255,255,255",0.92,66],[1.25,26.35,25.99,"255,255,255",0.56,66],[0.85,49.92,40.35,"255,255,255",0.62,66],[1.05,13.45,29.02,"255,255,255",0.92,66],[0.85,45.42,95.41,"255,255,255",0.62,66],[1.05,17.77,82.67,"255,255,255",0.86,66],[1.15,34.29,4.04,"245,160,58",0.92,70],[1.15,3.12,94.42,"255,255,255",0.68,66],[0.75,28.01,90.14,"255,255,255",0.8,66],[1.15,59.56,61.74,"255,255,255",0.62,66],[1.25,47.6,71.64,"255,255,255",0.68,66],[1.15,8.68,70.03,"255,255,255",0.5,66],[0.85,50.71,8.72,"255,255,255",0.8,66],[1.05,48.49,51.51,"255,255,255",0.92,66],[0.95,54.95,45.71,"255,255,255",0.74,66],[0.75,3.42,42.67,"255,255,255",0.68,66],[1.25,32.5,96.83,"255,255,255",0.68,66],[0.95,35.2,36.89,"255,255,255",0.8,66],[0.75,56.9,14.26,"255,255,255",0.8,66],[1.25,56.45,29.06,"255,255,255",0.74,66],[1.35,27.97,39.88,"245,160,58",0.92,70],[1.15,62.14,77.48,"255,255,255",0.8,66],[0.85,58.85,83.59,"255,255,255",0.5,66],[0.95,53.12,94.79,"255,255,255",0.68,66],[0.75,62.22,48.38,"255,255,255",0.56,66],[0.95,8.0,23.28,"255,255,255",0.92,66],[0.95,31.59,50.54,"255,255,255",0.56,66],[0.75,20.72,17.56,"255,255,255",0.8,66],[1.25,40.55,51.55,"255,255,255",0.74,66],[0.95,6.97,31.48,"255,255,255",0.8,66],[0.85,21.07,37.99,"255,255,255",0.56,66],[1.15,28.2,11.05,"255,255,255",0.5,66],[0.85,19.92,65.95,"255,255,255",0.86,66],[1.05,10.51,43.85,"255,255,255",0.92,66],[0.75,38.66,85.33,"255,255,255",0.68,66],[1.15,24.18,70.61,"255,255,255",0.68,66],[1.25,66.57,59.74,"245,160,58",0.92,70],[1.25,37.65,44.41,"255,255,255",0.56,66],[1.25,43.54,11.54,"255,255,255",0.74,66],[0.75,34.08,73.67,"255,255,255",0.86,66],[0.75,33.56,19.48,"255,255,255",0.5,66],[1.15,21.05,88.8,"255,255,255",0.74,66],[0.95,3.61,15.68,"255,255,255",0.5,66],[0.85,66.45,40.21,"255,255,255",0.62,66],[0.75,25.87,82.56,"255,255,255",0.92,66]]];
  var polygons = [
    [[43,0],[100,0],[100,100],[48,100],[38,86],[33,64],[33,40],[37,18]],
    [[0,0],[57,0],[63,18],[67,40],[67,64],[62,86],[52,100],[0,100]]
  ];
  var layers = [], pools = [[], []];
  var inView = false, ready = false, suspended = false, effectsEnabled = true;
  var timer = null, resizeFrame = 0;
  var lastDims = [], lastProximity = [], pointer = null, pointerFrame = 0;
  var geometry = null, geometryDirty = true;

  function makeCanvas(className, parent) {
    var canvas = document.createElement('canvas');
    canvas.className = className;
    canvas.setAttribute('aria-hidden', 'true');
    var ctx = canvas.getContext && canvas.getContext('2d', { alpha: true });
    if (!ctx) return null;
    if (parent) parent.appendChild(canvas);
    return { canvas: canvas, ctx: ctx, width: 0, height: 0, dpr: 0 };
  }
  function sizeLayer(layer, width, height, dpr) {
    if (layer.width === width && layer.height === height && layer.dpr === dpr) return false;
    layer.width = width; layer.height = height; layer.dpr = dpr;
    layer.canvas.width = Math.max(1, Math.round(width * dpr));
    layer.canvas.height = Math.max(1, Math.round(height * dpr));
    layer.canvas.style.width = width + 'px';
    layer.canvas.style.height = height + 'px';
    layer.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return true;
  }
  function drawStars(layer, index) {
    var ctx = layer.ctx, w = layer.width, h = layer.height;
    ctx.clearRect(0, 0, w, h);
    ctx.save(); ctx.beginPath();
    polygons[index].forEach(function (point, i) {
      ctx[i ? 'lineTo' : 'moveTo'](w * point[0] / 100, h * point[1] / 100);
    });
    ctx.closePath(); ctx.clip();
    STAR_MAPS[index].forEach(function (star) {
      var x = w * star[1] / 100, y = h * star[2] / 100, r = star[0];
      // Glow is baked only on resize, never filtered over the whole panel.
      var glow = ctx.createRadialGradient(x, y, 0, x, y, r + 4);
      glow.addColorStop(0, 'rgba(' + star[3] + ',0.12)');
      glow.addColorStop(1, 'rgba(' + star[3] + ',0)');
      ctx.fillStyle = glow; ctx.fillRect(x-r-4, y-r-4, (r+4)*2, (r+4)*2);
      var core = ctx.createRadialGradient(x, y, 0, x, y, r);
      core.addColorStop(0, 'rgba(' + star[3] + ',' + star[4] + ')');
      core.addColorStop(star[5] / 100, 'rgba(' + star[3] + ',0)');
      core.addColorStop(1, 'rgba(' + star[3] + ',0)');
      ctx.fillStyle = core; ctx.fillRect(x-r, y-r, r*2, r*2);
    });
    ctx.restore();
  }
  function measure() {
    geometryDirty = true;
    if (!ready || !desktop.matches) return;
    // All layout reads precede canvas writes; particles need no frame-by-frame layout reads.
    var sizes = panels.map(function (panel) { return { w: panel.clientWidth, h: panel.clientHeight }; });
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    sizes.forEach(function (size, index) {
      if (!size.w || !size.h) return;
      if (!layers[index]) {
        var stars = makeCanvas('ggg-star-canvas', panels[index].querySelector('.ggg-panel-dim-layer'));
        if (!stars) return;
        layers[index] = { stars: stars };
      }
      var pair = layers[index];
      if (sizeLayer(pair.stars, size.w, size.h, dpr)) drawStars(pair.stars, index);
    });
  }
  function canAnimate() {
    return ready && inView && desktop.matches && pointerQuery.matches && !reduced.matches &&
      !document.hidden && !suspended && effectsEnabled;
  }
  function acquire(index) {
    var pool = pools[index];
    for (var i = 0; i < pool.length; i++) if (!pool[i].busy) return pool[i];
    // Enough slots for the original 220ms cadence and maximum 4.5s / 8s life.
    if (pool.length >= (index === 0 ? 22 : 37)) return null;
    var node = document.createElement('span');
    node.className = 'ggg-atmos-particle ' + (index === 0 ? 'ggg-ember' : 'ggg-ash');
    node.setAttribute('aria-hidden', 'true');
    panels[index].appendChild(node);
    var slot = { node: node, busy: false, animation: null };
    pool.push(slot);
    return slot;
  }
  function spawn(index) {
    var slot = acquire(index);
    if (!slot) return;
    slot.busy = true;
    var node = slot.node;
    var size = 2 + Math.random() * 3;
    node.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (Math.random() * 100) + '%;' + (index === 0 ? 'bottom:-8px;' : 'top:24px;');
    var drift = (Math.random() - 0.5) * 44;
    var frames = index === 0 ? [
      { transform: 'translate3d(0,0,0)', opacity: 0 },
      { opacity: 0.95, offset: 0.15 },
      { opacity: 0.68, offset: 0.72 },
      { transform: 'translate3d(' + drift + 'px,-340px,0)', opacity: 0 }
    ] : [
      { transform: 'translate3d(0,0,0)', opacity: 0.85 },
      { transform: 'translate3d(' + drift + 'px,340px,0)', opacity: 0 }
    ];
    var animation = node.animate(frames, {
      duration: index === 0 ? 2500 + Math.random() * 2000 : 4500 + Math.random() * 3500,
      easing: index === 0 ? 'ease-out' : 'linear'
    });
    slot.animation = animation;
    function release() {
      if (slot.animation !== animation) return;
      node.style.display = 'none';
      slot.busy = false;
      slot.animation = null;
    }
    animation.onfinish = release;
    animation.oncancel = release;
  }
  function tick() {
    if (!canAnimate()) { stop(); return; }
    spawn(0); spawn(1);
  }
  function stop() {
    if (timer !== null) window.clearInterval(timer);
    timer = null;
    pools.forEach(function (pool) {
      pool.forEach(function (slot) {
        var animation = slot.animation;
        slot.animation = null;
        if (animation) animation.cancel();
        slot.node.style.display = 'none';
        slot.busy = false;
      });
    });
  }
  function sync() {
    root.classList.toggle('ggg-atmosphere-ready', desktop.matches && pointerQuery.matches);
    if (!desktop.matches || !pointerQuery.matches) resetLighting();
    if (!canAnimate()) { stop(); return; }
    if (timer !== null) return;
    tick();
    timer = window.setInterval(tick, 220);
  }
  function resize() {
    geometryDirty = true;
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(function () { resizeFrame = 0; measure(); sync(); });
  }
  function dim(index, value) {
    var next = value.toFixed(3);
    if (lastDims[index] === next || !shades[index]) return;
    lastDims[index] = next; shades[index].style.opacity = next;
  }
  function proximity(index, value) {
    var next = value.toFixed(3);
    if (lastProximity[index] === next) return;
    lastProximity[index] = next; edgeGlows[index].style.opacity = next;
  }
  function resetLighting() { dim(0,.52); dim(1,.52); proximity(0,0); proximity(1,0); }
  function brightnessToDim(brightness) {
    var amount = Math.max(0,Math.min(1,(brightness-.45)/.63));
    return Math.max(.02,Math.min(.72,.58-.56*Math.pow(amount,.55)));
  }
  function light() {
    pointerFrame = 0;
    if (!desktop.matches || !pointerQuery.matches || document.hidden || !pointer) return;
    if (geometryDirty || !geometry) { geometry = root.getBoundingClientRect(); geometryDirty = false; }
    var rect = geometry;
    if (pointer.x < rect.left || pointer.x > rect.right || pointer.y < rect.top || pointer.y > rect.bottom) { resetLighting(); return; }
    var active = root.classList.contains('hover-left') ? 0 : root.classList.contains('hover-right') ? 1 : -1;
    if (active !== -1) { dim(active,.02); dim(1-active,.58); proximity(active,1); proximity(1-active,0); return; }
    var x = (pointer.x-rect.left)/rect.width;
    active = x < .5 ? 0 : 1;
    var strength = Math.max(0,Math.min(1,Math.abs(x-.5)/.3));
    dim(active,brightnessToDim(.45+.65*strength)); dim(1-active,brightnessToDim(.45-.27*strength));
    proximity(active,strength); proximity(1-active,0);
  }
  root.addEventListener('pointermove', function (event) {
    if (!desktop.matches || !pointerQuery.matches || (event.pointerType && !/^(mouse|pen)$/.test(event.pointerType))) return;
    pointer = { x: event.clientX, y: event.clientY };
    if (!pointerFrame) pointerFrame = window.requestAnimationFrame(light);
  }, { passive: true });
  root.addEventListener('pointerleave', function () {
    pointer = null;
    if (pointerFrame) window.cancelAnimationFrame(pointerFrame);
    pointerFrame = 0; resetLighting();
  });
  new MutationObserver(function () {
    if (root.classList.contains('hover-left')) { dim(0,.02); dim(1,.58); proximity(0,1); proximity(1,0); }
    else if (root.classList.contains('hover-right')) { dim(1,.02); dim(0,.58); proximity(1,1); proximity(0,0); }
    else resetLighting();
  }).observe(root, { attributes: true, attributeFilter: ['class'] });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; sync(); }, { threshold: 0 }).observe(root);
  } else { inView = true; }
  if ('ResizeObserver' in window) {
    var observer = new ResizeObserver(resize);
    panels.forEach(function (panel) { observer.observe(panel); });
  }
  window.addEventListener('resize', resize, { passive: true });
  window.addEventListener('scroll', function () { geometryDirty = true; }, { passive: true });
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('pagehide', function () { suspended = true; stop(); });
  window.addEventListener('pageshow', function () { suspended = false; resize(); });
  desktop.addEventListener('change', resize);
  pointerQuery.addEventListener('change', sync);
  reduced.addEventListener('change', sync);
  resetLighting();
  window.GGGHero.setEffectsEnabled = function (enabled) { effectsEnabled = !!enabled; sync(); };
  window.GGGHero.effectStats = function () {
    return { running: timer !== null,
      particleCount: pools.reduce(function (count, pool) {
        return count + pool.filter(function (slot) { return slot.busy; }).length;
      }, 0),
      particleSlots: pools[0].length + pools[1].length,
      canvases: layers.length, stars: STAR_MAPS[0].length+STAR_MAPS[1].length };
  };
  window.GGGHero.idle(function () { ready = true; measure(); sync(); });
})();


/* ===== extracted script block 11 ===== */
/* Retired:
   The old three-card content-rotation logic has been replaced by the
   23-card cycling stack block above. Keeping this block empty prevents
   duplicate click handlers from fighting the new card sequence. */
(function () {
  return;
})();

/* ===== extracted script blocks 12-18 ===== */
/* V13 deferred: Ultimate Edition hydration, rails, sizing, and detail-panel helpers
   now initialize only when the Ultimate section is close to view. */
window.GGG_initUltimateSection = window.GGG_initUltimateSection || function () {
  if (window.GGG_ultimateSectionInitialized) return;
  window.GGG_ultimateSectionInitialized = true;

/* Ultimate grid uses natural height; the complete main artwork remains visible. */
/* ===== extracted script block 13 ===== */
(function() {
  var SLIDE_BG = ['#1e1828', '#1a1e2a', '#1e2218', '#281e1a'];

  var fallbackItems = [
    { key:'original-edition-deck', emoji:'🃏', cat:'PLAYING CARD DECK', name:'Original Edition Deck', desc:'The original 23-card Terror Tarot deck. Hand-illustrated with gothic detail, each card draws from classic tarot archetypes reinterpreted through a horror lens.', price:'$34.95', slides:3, img:assetUrl('final_carousel_021.webp') , customThumbs:{mobile:assetUrl('ult-thumb-original-edition-deck-mobile-220w.webp'),desktop:assetUrl('ult-thumb-original-edition-deck-desktop-260w.webp'),retina:assetUrl('ult-thumb-original-edition-deck-retina-360w.webp')}},
    { key:'shadow-edition-deck', emoji:'🌑', cat:'PLAYING CARD DECK', name:'Shadow Edition Deck', desc:'A second deck in an inverted shadow colorway with deep blacks and silver highlights. Pairs with the Original Edition for a full dual-deck experience.', price:'$34.95', slides:3, img:assetUrl('final_carousel_024.webp') , customThumbs:{mobile:assetUrl('ult-thumb-shadow-edition-deck-mobile-220w.webp'),desktop:assetUrl('ult-thumb-shadow-edition-deck-desktop-260w.webp'),retina:assetUrl('ult-thumb-shadow-edition-deck-retina-360w.webp')}},
    { key:'terror-tarot-tapestry', emoji:'🖼️', cat:'WALL TAPESTRY 60x50"', name:'Terror Tarot Tapestry', desc:'A large-format woven tapestry featuring your chosen card design. Printed on soft, high-quality fabric, a stunning centerpiece for any space.', price:'$34.95', slides:2, img:assetUrl('Hermit Tapestry Main No Text.webp') , customThumbs:{mobile:assetUrl('ult-thumb-terror-tarot-tapestry-mobile-220w.webp'),desktop:assetUrl('ult-thumb-terror-tarot-tapestry-desktop-260w.webp'),retina:assetUrl('ult-thumb-terror-tarot-tapestry-retina-360w.webp')}},
    {"key": "custom-box-artwork", "name": "Custom Box Artwork", "cat": "CUSTOM BOX PRINTING", "desc": "Custom Terror Tarot artwork wraps the collection’s presentation box, with a star-filled purple interior and printed details inside the lid and base.", "alt": "Closed and open purple Terror Tarot presentation box showing its custom exterior and interior artwork", "price": "", "slides": 1, "approvedArtwork": true, img:assetUrl("ggg-ult-custom-box-artwork-final-v4-260w.webp"), detailImg:assetUrl("ggg-ult-custom-box-artwork-final-v4-1254w.webp"), retinaImg:assetUrl("ggg-ult-custom-box-artwork-final-v4-520w.webp") },
    { key:'original-sticker-pack', emoji:'✦', cat:'STICKER PACK', name:'Original Sticker Pack', desc:'Premium die-cut vinyl stickers featuring iconic imagery from the original deck. Water-resistant and built to last.', price:'$12.95', slides:2, img:assetUrl('og-sticker-pack-laptop.webp') },
    { key:'shadow-sticker-pack', emoji:'✦', cat:'STICKER PACK', name:'Shadow Sticker Pack', desc:'The Shadow Edition counterpart sticker pack in the inverted colorway. Collect both for the full set.', price:'$12.95', slides:2, img:assetUrl('shadow-sticker-pack-laptop.webp') },
    { key:'magnetic-gift-box', emoji:'📦', cat:'GIFT PACKAGING', name:'Magnetic Gift Box', desc:'A premium magnetic-closure gift box for the entire collection. Rigid matte-black construction, worthy of what is inside.', price:'$19.95', slides:2, img:assetUrl('final_carousel_026.webp') },
    { key:'original-guidebook', emoji:'📖', cat:'DIGITAL GUIDE', name:'Original Guidebook', desc:'An in-depth digital companion to the original deck. Covers card meanings, reading techniques, spreads, and the lore behind each illustration.', price:'$24.95', slides:2, img:assetUrl('final_carousel_009.webp') },
    { key:'shadow-guidebook', emoji:'📖', cat:'DIGITAL GUIDE', name:'Shadow Guidebook', desc:'The Shadow Edition companion guide with alternate interpretations, reversed meanings, and additional spreads.', price:'$24.95', slides:2, img:assetUrl('final_carousel_022.webp') },
    { key:'wallpaper-collection', emoji:'📱', cat:'DIGITAL DOWNLOAD · 46 IMAGES', name:'Wallpaper Collection', desc:'All 46 Terror Tarot card illustrations as high-resolution phone wallpapers. Instant digital delivery upon purchase.', price:'$49.95', slides:3, img:assetUrl('final_carousel_006.webp') },
    {"key": "founders-letter", "name": "Founder’s Letter", "cat": "A PERSONAL WELCOME", "desc": "A personal welcome from co-founder Shanna Stoker, exploring the light and shadow behind Terror Tarot. Presented in black and gold with a matching envelope.", "alt": "Black-and-gold Founder’s Letter and matching envelope arranged on purple velvet with dried herbs and rune stones", "price": "", "slides": 1, "approvedArtwork": true, img:assetUrl("ggg-ult-founders-letter-260w.webp"), detailImg:assetUrl("ggg-ult-founders-letter-1254w.webp"), retinaImg:assetUrl("ggg-ult-founders-letter-520w.webp") },
    {"key": "certificate-of-authenticity", "name": "Certificate of Authenticity", "cat": "THE FOUNDER’S ARCHIVE", "desc": "Your Founder’s Collection certificate, presented inside The Founder’s Archive protective booklet with intricate gold detailing and the “Sworn and Sealed” introduction.", "alt": "Founder’s Archive booklet showing the gold-detailed cover, Sworn and Sealed introduction, and Certificate of Authenticity", "price": "", "slides": 1, "approvedArtwork": true, img:assetUrl("ggg-ult-certificate-of-authenticity-260w.webp"), detailImg:assetUrl("ggg-ult-certificate-of-authenticity-1254w.webp"), retinaImg:assetUrl("ggg-ult-certificate-of-authenticity-520w.webp") },
  ];

  var productMedia = window.GGG_ULTIMATE_PRODUCT_MEDIA || { items: [] };
  var sourceByKey = {};
  (productMedia.items || []).forEach(function(source) {
    if (source && source.key) sourceByKey[source.key] = source;
  });

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, 'and')
      .replace(/[^a-z0-9]+/g, '');
  }

  function normalizedIncludes(haystack, needle) {
    var n = normalize(needle);
    if (!n) return false;

    var h = normalize(haystack);
    if (h && h.indexOf(n) !== -1) return true;

    var cn = compact(needle);
    return !!(cn && compact(haystack).indexOf(cn) !== -1);
  }

  function selectUltimateThumb(item) {
    if (!item || !item.customThumbs) return '';

    var thumbs = item.customThumbs;
    var isMobile = window.matchMedia &&
      window.matchMedia('(max-width: 700px)').matches;

    if (isMobile && thumbs.mobile) return thumbs.mobile;

    if (window.devicePixelRatio && window.devicePixelRatio >= 1.5 && thumbs.retina) {
      return thumbs.retina;
    }

    return thumbs.desktop || thumbs.mobile || thumbs.retina || '';
  }

  function sameId(a, b) {
    return String(a || '') === String(b || '');
  }

  function uniqueBySrc(list) {
    var seen = {};
    var out = [];

    (list || []).forEach(function(photo) {
      if (!photo) return;
      var src = photo.src || photo.thumbSrc;
      if (!src || seen[src]) return;
      seen[src] = true;
      out.push(photo);
    });

    return out;
  }

  function getProductImages(source) {
    return (source && source.images && source.images.length) ? source.images : [];
  }

  function getProductVariants(source) {
    return (source && source.variants && source.variants.length) ? source.variants : [];
  }

  function findVariant(source) {
    var variants = getProductVariants(source);
    if (!variants.length) return null;

    var wantedSku = normalize(source && source.sku);
    var wantedCompactSku = compact(source && source.sku);
    var wantedId = String((source && source.variantId) || '');

    if (wantedId) {
      for (var a = 0; a < variants.length; a++) {
        if (sameId(variants[a].id, wantedId)) return variants[a];
      }
    }

    if (wantedSku || wantedCompactSku) {
      for (var b = 0; b < variants.length; b++) {
        if (normalize(variants[b].sku) === wantedSku || compact(variants[b].sku) === wantedCompactSku) return variants[b];
      }
    }

    return variants[0];
  }

  function pushTerm(terms, term) {
    term = String(term || '').trim();
    if (!term) return;
    if (normalize(term) === 'default title') return;
    if (terms.indexOf(term) === -1) terms.push(term);
  }

  function getMatchTerms(source, variant, item) {
    var terms = [];

    pushTerm(terms, source && source.altKey);
    pushTerm(terms, source && source.sku);
    pushTerm(terms, source && source.key);
    pushTerm(terms, item && item.key);
    pushTerm(terms, variant && variant.sku);
    pushTerm(terms, variant && variant.title);
    pushTerm(terms, item && item.name);

    if (variant && variant.options) {
      variant.options.forEach(function(option) { pushTerm(terms, option); });
    }

    return terms;
  }

  function imageLinkedToVariant(image, variant) {
    if (!image || !variant || !image.variantIds) return false;
    return image.variantIds.some(function(id) { return sameId(id, variant.id); });
  }

  function imageMatchesTerms(image, source, variant, item) {
    if (!image) return false;
    if (imageLinkedToVariant(image, variant)) return true;

    var alt = image.alt || '';
    var terms = getMatchTerms(source, variant, item);

    for (var i = 0; i < terms.length; i++) {
      if (normalizedIncludes(alt, terms[i])) return true;
    }

    return false;
  }

  function altHasAnyWord(image, words) {
    var alt = normalize(image && image.alt);
    if (!alt) return false;

    return words.some(function(word) {
      return alt.indexOf(normalize(word)) !== -1;
    });
  }

  function isThumbnailImage(image) {
    return altHasAnyWord(image, ['thumbnail', 'thumb', 'menu image', 'menu thumbnail', 'grid image', 'grid thumbnail', 'ultimate thumbnail']);
  }

  function isPreferredHeroImage(image) {
    return altHasAnyWord(image, ['hero', 'main', 'cover', 'featured']);
  }

  function imageToPhoto(image, item) {
    if (!image) return null;
    var src = image.src || image.thumbSrc;
    if (!src) return null;

    return {
      id: image.id || src,
      src: src,
      thumbSrc: image.thumbSrc || src,
      alt: image.alt || (item && item.name) || ''
    };
  }

  function hydrateItem(item) {
    if (item.approvedArtwork) {
      if (window.devicePixelRatio >= 1.5) item.img = item.retinaImg;
      item.photos = [{src:item.detailImg,thumbSrc:item.img,alt:item.alt}];
      return item;
    }
    var source = sourceByKey[item.key];
    if (!source || !getProductImages(source).length) {
      item.photos = item.img ? [{ src: item.img, thumbSrc: item.img, alt: item.name }] : [];
      item.img = selectUltimateThumb(item) || item.img;
      return item;
    }

    var variant = findVariant(source);
    var productImages = getProductImages(source);
    var variantLinked = productImages.filter(function(image) { return imageLinkedToVariant(image, variant); });
    var altMatched = productImages.filter(function(image) { return imageMatchesTerms(image, source, variant, item); });
    var photoCandidates = uniqueBySrc(variantLinked.concat(altMatched));

    if (!photoCandidates.length && variant && variant.featuredImage) {
      photoCandidates = [variant.featuredImage];
    }

    if (!photoCandidates.length && productImages.length === 1) {
      photoCandidates = productImages.slice();
    }

    if (!photoCandidates.length) {
      photoCandidates = productImages.slice();
    }

    var thumbCandidates = productImages.filter(function(image) {
      return isThumbnailImage(image) && imageMatchesTerms(image, source, variant, item);
    });

    if (!thumbCandidates.length) {
      thumbCandidates = photoCandidates.filter(isThumbnailImage);
    }

    if (!thumbCandidates.length) {
      thumbCandidates = photoCandidates.filter(isPreferredHeroImage);
    }

    var fallbackThumb = thumbCandidates[0] || (variant && variant.featuredImage) || photoCandidates[0];
    var thumbPhoto = imageToPhoto(fallbackThumb, item);

    var customThumb = selectUltimateThumb(item);
    item.img = customThumb || (thumbPhoto ? (thumbPhoto.thumbSrc || thumbPhoto.src) : item.img);
    item.photos = uniqueBySrc(photoCandidates.map(function(image) { return imageToPhoto(image, item); }));
    item.slides = item.photos.length || item.slides || 1;
    item.productSource = source;
    item.productVariant = variant;

    return item;
  }

  var items = fallbackItems.map(function(item) {
    return hydrateItem(Object.assign({}, item, {price:''}));
  });

  var curItem = 0;
  var curPhoto = 0;
  var touchStartX = 0;
  var grid = document.getElementById('ult-item-grid');
  var panel = document.getElementById('ult-detail-panel');
  if (!grid) return;

  function getSlideCount(item) {
    if (item && item.photos && item.photos.length) return item.photos.length;
    return Math.max(1, item && item.slides ? item.slides : 1);
  }

  function thumbHtml(className, item, altSuffix) {
    var src = item && item.img;
    var alt = (item && (item.alt || item.name) ? (item.alt || item.name) : 'Ultimate Edition item') + (altSuffix || '');

    if (src) {
      return '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt) + '" loading="lazy" decoding="async" onerror="this.style.display=\'none\'">';
    }

    return '<span class="' + escapeHtml(className || '') + '">' + escapeHtml(item && item.emoji ? item.emoji : '✦') + '</span>';
  }

  function toggleCarouselControls(total) {
    var outer = document.getElementById('ult-carousel-outer');
    var dots = document.getElementById('ult-c-dots');
    var arrows = outer ? outer.querySelectorAll('.ult-c-arr') : [];
    var hide = total <= 1;

    if (outer) {
      outer.classList.toggle('is-multiple-photos', !hide);
      outer.dataset.photoCount = String(total || 0);
    }

    if (dots) {
      dots.classList.toggle('is-hidden', hide);
      dots.setAttribute('aria-hidden', hide ? 'true' : 'false');
    }

    arrows.forEach(function(arrow) {
      arrow.classList.toggle('is-hidden', hide);
      arrow.disabled = hide;
      arrow.setAttribute('aria-hidden', hide ? 'true' : 'false');

      /*
        Some later desktop layout fixes use very strong CSS to lock the carousel
        into a square frame. When Shopify/product-reference media rebuilds the
        carousel, the old hidden state can otherwise win and make the desktop
        navigation arrows disappear even though there are multiple photos.
      */
      if (hide) {
        arrow.style.setProperty('display', 'none', 'important');
        arrow.style.setProperty('visibility', 'hidden', 'important');
        arrow.style.setProperty('opacity', '0', 'important');
        arrow.style.setProperty('pointer-events', 'none', 'important');
      } else {
        arrow.style.setProperty('display', 'flex', 'important');
        arrow.style.setProperty('visibility', 'visible', 'important');
        arrow.style.setProperty('opacity', '1', 'important');
        arrow.style.setProperty('pointer-events', 'auto', 'important');
        arrow.style.removeProperty('disabled');
      }
    });
  }

  // Build grid
  items.forEach(function(item, i) {
    var card = document.createElement('div');
    card.className = 'ult-item-card' + (item.img ? ' has-product-media' : '');
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.innerHTML =
      '<div class="ult-item-thumb" style="background:' + escapeHtml(SLIDE_BG[i % 4]) + '">' +
        thumbHtml('', item, ' thumbnail') +
      '</div>' +
      '<div class="ult-item-info">' +
        '<div class="ult-item-name">' + escapeHtml(item.name) + '</div>' +
        '<div class="ult-item-meta">' +
          (item.price ? '<span class="ult-item-val">' + escapeHtml(item.price) + '</span>' : '<span></span>') +
          '<span class="ult-item-incl">INCLUDED</span>' +
        '</div>' +
      '</div>';

    card.addEventListener('click', function() { triggerOpen(i, card); });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        triggerOpen(i, card);
      }
    });

    grid.appendChild(card);
  });

  function triggerOpen(idx, cardEl) {
    cardEl.classList.add('flipping');
    setTimeout(function() { openDetail(idx); }, 200);
    setTimeout(function() { cardEl.classList.remove('flipping'); }, 420);
  }

  function getMiniRailScrollLeft() {
    var rail = document.getElementById('ult-mini-grid');
    return rail ? rail.scrollLeft : 0;
  }

  function restoreMiniRailScrollLeft(value) {
    value = Number(value) || 0;

    function apply() {
      var rail = document.getElementById('ult-mini-grid');
      if (!rail) return;

      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      rail.scrollLeft = Math.max(0, Math.min(value, max));
    }

    apply();
    window.requestAnimationFrame(apply);
    window.setTimeout(apply, 50);
    window.setTimeout(apply, 180);
    window.setTimeout(apply, 420);
  }

  function openDetail(idx) {
    var shouldPreserveMiniRail = panel.classList.contains('open') && !!document.getElementById('ult-mini-grid');
    var previousMiniRailScroll = shouldPreserveMiniRail ? getMiniRailScrollLeft() : 0;

    curItem = idx;
    curPhoto = 0;
    var item = items[idx];

    document.getElementById('ult-d-header-name').textContent = item.name;
    document.getElementById('ult-d-cat').textContent = item.cat;
    document.getElementById('ult-d-name').textContent = item.name;
    document.getElementById('ult-d-desc').textContent = item.desc;
    document.getElementById('ult-d-price').textContent = item.price || 'Included with bundle';

    buildCarousel(item);
    buildMiniGrid(idx);
    panel.classList.add('open');

    if (shouldPreserveMiniRail) {
      restoreMiniRailScrollLeft(previousMiniRailScroll);
    }
  }

  window.ultCloseDetail = function() {
    panel.classList.remove('open');
  };

  window.ultMoveCarousel = function(dir) {
    var slides = getSlideCount(items[curItem]);
    if (slides <= 1) return;

    curPhoto = (curPhoto + dir + slides) % slides;
    goToSlide(curPhoto);
  };

  function buildCarousel(item) {
    var track = document.getElementById('ult-carousel-track');
    var dots = document.getElementById('ult-c-dots');
    var photos = item.photos || [];
    var total = getSlideCount(item);

    track.innerHTML = '';
    dots.innerHTML = '';

    if (photos.length) {
      photos.forEach(function(photo, i) {
        var slide = document.createElement('div');
        slide.className = 'ult-carousel-slide has-image';
        slide.style.background = SLIDE_BG[i % SLIDE_BG.length];
        slide.innerHTML = '<img class="ult-carousel-photo" src="' + escapeHtml(photo.src) + '" alt="' + escapeHtml(photo.alt || item.name) + '" loading="lazy" decoding="async">';
        track.appendChild(slide);
      });
    } else {
      for (var i = 0; i < total; i++) {
        var slide = document.createElement('div');
        slide.className = 'ult-carousel-slide is-placeholder';
        slide.style.background = SLIDE_BG[i % SLIDE_BG.length];
        slide.innerHTML =
          '<span style="font-size:2.2rem;opacity:.3">' + escapeHtml(item.emoji) + '</span>' +
          '<span style="font-family:\'Barlow Condensed\',sans-serif;font-size:.62rem;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.18);margin-top:6px">PHOTO ' + (i + 1) + ' OF ' + total + '</span>';
        track.appendChild(slide);
      }
    }

    for (var d = 0; d < total; d++) {
      (function(idx) {
        var dot = document.createElement('div');
        dot.className = 'ult-c-dot' + (idx === 0 ? ' active' : '');
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('aria-label', 'Show photo ' + (idx + 1));
        dot.addEventListener('click', function() { curPhoto = idx; goToSlide(idx); });
        dot.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            curPhoto = idx;
            goToSlide(idx);
          }
        });
        dots.appendChild(dot);
      })(d);
    }

    track.style.transform = 'translateX(0)';
    toggleCarouselControls(total);
    setupTouch();

    if (window.GGG_syncUltimateCarouselControls) {
      window.GGG_syncUltimateCarouselControls();
    }
  }

  function goToSlide(idx) {
    var slides = getSlideCount(items[curItem]);
    curPhoto = (idx + slides) % slides;
    document.getElementById('ult-carousel-track').style.transform = 'translateX(-' + (curPhoto * 100) + '%)';
    document.querySelectorAll('.ult-c-dot').forEach(function(dot, i) {
      dot.classList.toggle('active', i === curPhoto);
    });
  }

  function buildMiniGrid(activeIdx) {
    var wrap = document.getElementById('ult-mini-grid-wrap');
    if (!wrap) return;

    wrap.innerHTML = '<p class="ult-mini-grid-label">EXPLORE THE COLLECTION · CLICK TO BROWSE</p><div class="ult-mini-grid" id="ult-mini-grid"></div>';

    var miniGrid = document.getElementById('ult-mini-grid');

    items.forEach(function(item, i) {
      var cell = document.createElement('div');
      cell.className = 'ult-mini-cell' + (i === activeIdx ? ' active' : '') + (item.img ? ' has-product-media' : '');
      cell.setAttribute('role', 'button');
      cell.setAttribute('tabindex', '0');

      cell.innerHTML =
        '<div class="ult-mini-thumb" style="background:' + escapeHtml(SLIDE_BG[i % 4]) + '">' +
          thumbHtml('ult-mini-icon', item, ' thumbnail') +
        '</div>' +
        '<div class="ult-mini-info">' +
          '<div class="ult-mini-name">' + escapeHtml(item.name) + '</div>' +
          '<div class="ult-mini-meta">' +
            (item.price ? '<span class="ult-mini-val">' + escapeHtml(item.price) + '</span>' : '<span class="ult-mini-val"></span>') +
            '<span class="ult-mini-incl">INCLUDED</span>' +
          '</div>' +
        '</div>';

      cell.addEventListener('click', function() {
        if (i !== curItem) openDetail(i);
      });
      cell.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (i !== curItem) openDetail(i);
        }
      });

      miniGrid.appendChild(cell);
    });
  }

  function setupTouch() {
    var outer = document.getElementById('ult-carousel-outer');
    if (!outer) return;

    outer.removeEventListener('touchstart', onTS);
    outer.removeEventListener('touchend', onTE);
    outer.addEventListener('touchstart', onTS, { passive: true });
    outer.addEventListener('touchend', onTE, { passive: true });
  }

  function onTS(e) {
    touchStartX = e.touches[0].clientX;
  }

  function onTE(e) {
    var d = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(d) > 36) ultMoveCarousel(d < 0 ? 1 : -1);
  }

  window.GGG_ULTIMATE_ITEMS = items;
})();



/* GGG Ultimate item-grid thumbnail marker:
   First three Ultimate grid thumbnails use custom responsive WebP assets:
   mobile 220w, desktop 260w, retina 360w. Detail-panel images are unchanged. */
window.GGG_ULTIMATE_GRID_THUMBS_OPTIMIZED = '220-260-360-v1';

/* ===== extracted script block 14 ===== */
(function () {
  var panel = document.getElementById('ult-detail-panel');
  var rightPanel = document.getElementById('ult-right-panel');
  if (!panel || !rightPanel) return;

  function syncUltimateDetailOpenState() {
    rightPanel.classList.toggle('ult-mobile-detail-open', panel.classList.contains('open'));
  }

  syncUltimateDetailOpenState();

  if (window.MutationObserver) {
    new MutationObserver(syncUltimateDetailOpenState).observe(panel, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('click', function () {
    window.requestAnimationFrame(syncUltimateDetailOpenState);
  }, true);

  window.addEventListener('resize', syncUltimateDetailOpenState, { passive: true });
  window.addEventListener('orientationchange', syncUltimateDetailOpenState, { passive: true });
})();


/* ===== extracted script block 15 ===== */
(function () {
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 1000px)') : null;

  function isMobile() {
    return !mobileQuery || mobileQuery.matches;
  }

  function clampScrollLeft(rail) {
    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    if (rail.scrollLeft < 0) rail.scrollLeft = 0;
    if (rail.scrollLeft > max) rail.scrollLeft = max;
  }

  function updateArrowState(rail, leftBtn, rightBtn) {
    if (!rail || !leftBtn || !rightBtn) return;
    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var left = rail.scrollLeft;
    var canScroll = max > 2;

    leftBtn.classList.toggle('is-disabled', !canScroll || left <= 2);
    rightBtn.classList.toggle('is-disabled', !canScroll || left >= max - 2);
  }

  function makeButton(direction, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ult-rail-arrow ult-rail-arrow-' + direction;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = direction === 'left' ? '&#8249;' : '&#8250;';
    return btn;
  }

  function setupRail(rail, type) {
    if (!rail || rail.dataset.ultRailArrowsReady === '1') return;

    var parent = rail.parentNode;
    if (!parent) return;

    var wrap = rail.closest('.ult-mobile-rail-nav-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'ult-mobile-rail-nav-wrap ' + (type === 'detail' ? 'ult-detail-rail-nav-wrap' : 'ult-main-rail-nav-wrap');
      parent.insertBefore(wrap, rail);
      wrap.appendChild(rail);
    } else {
      wrap.classList.add(type === 'detail' ? 'ult-detail-rail-nav-wrap' : 'ult-main-rail-nav-wrap');
    }

    rail.classList.add('ult-rail-has-arrows');
    rail.dataset.ultRailArrowsReady = '1';

    var leftBtn = makeButton('left', type === 'detail' ? 'Scroll included items left' : 'Scroll bundle items left');
    var rightBtn = makeButton('right', type === 'detail' ? 'Scroll included items right' : 'Scroll bundle items right');

    wrap.appendChild(leftBtn);
    wrap.appendChild(rightBtn);

    function scrollByDirection(dir) {
      if (!isMobile()) return;
      var distance = Math.max(rail.clientWidth * 0.72, 120);
      rail.scrollBy({ left: dir * distance, behavior: 'smooth' });
      window.setTimeout(function () { updateArrowState(rail, leftBtn, rightBtn); }, 260);
    }

    leftBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scrollByDirection(-1);
    });

    rightBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scrollByDirection(1);
    });

    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateArrowState(rail, leftBtn, rightBtn);
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      clampScrollLeft(rail);
      updateArrowState(rail, leftBtn, rightBtn);
    }, { passive: true });

    window.addEventListener('orientationchange', function () {
      window.setTimeout(function () {
        clampScrollLeft(rail);
        updateArrowState(rail, leftBtn, rightBtn);
      }, 180);
    }, { passive: true });

    window.requestAnimationFrame(function () {
      updateArrowState(rail, leftBtn, rightBtn);
    });
  }

  function setupUltimateRails() {
    setupRail(document.getElementById('ult-item-grid'), 'main');
    setupRail(document.getElementById('ult-mini-grid'), 'detail');
  }

  setupUltimateRails();
  document.addEventListener('DOMContentLoaded', setupUltimateRails);
  window.addEventListener('load', setupUltimateRails, { passive: true });

  document.addEventListener('click', function () {
    window.requestAnimationFrame(setupUltimateRails);
    window.setTimeout(setupUltimateRails, 80);
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      setupUltimateRails();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();


/* ===== extracted script block 16 ===== */
(function () {
  // Retired compatibility block.
  // The previous version used a MutationObserver to strip max-height from
  // #ult-right-panel. The final no-crop alignment intentionally keeps that
  // max-height so the purchase module compresses to the live photo height.
})();


/* ===== extracted script block 17 ===== */
(function () {
  function updateUltimateMobileLabel() {
    var label = document.querySelector('.ultimate-section .ult-grid-label');
    if (!label) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 1000px)').matches;
    label.textContent = isMobile
      ? 'EXPLORE THE COLLECTION · SWIPE TO BROWSE'
      : 'EXPLORE THE COLLECTION · CLICK ANY TILE TO LEARN MORE';
  }

  updateUltimateMobileLabel();
  window.addEventListener('resize', updateUltimateMobileLabel, { passive: true });
  window.addEventListener('orientationchange', updateUltimateMobileLabel, { passive: true });
  document.addEventListener('DOMContentLoaded', updateUltimateMobileLabel);
})();


/* ===== extracted script block 18 ===== */
(function () {
  var panel = document.getElementById('ult-detail-panel');
  var rightPanel = document.getElementById('ult-right-panel');
  if (!panel || !rightPanel) return;

  function ensureInfoStack() {
    var body = panel.querySelector('.ult-detail-body');
    if (!body) return null;

    var stack = panel.querySelector('.ult-d-info-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'ult-d-info-stack';
      var mini = panel.querySelector('.ult-mini-grid-wrap');
      body.insertBefore(stack, mini || null);
    }

    ['ult-d-cat', 'ult-d-name', 'ult-d-desc'].forEach(function (cls) {
      var el = panel.querySelector('.' + cls);
      if (el && el.parentNode !== stack) stack.appendChild(el);
    });

    var footer = panel.querySelector('.ult-d-footer');
    if (footer && footer.parentNode !== stack) stack.appendChild(footer);

    return stack;
  }

  function syncOpenState() {
    var isOpen = panel.classList.contains('open');
    rightPanel.classList.toggle('ult-mobile-detail-open', isOpen);
    if (isOpen) ensureInfoStack();
  }

  ensureInfoStack();
  syncOpenState();

  if (window.MutationObserver) {
    new MutationObserver(syncOpenState).observe(panel, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('click', function () {
    window.requestAnimationFrame(syncOpenState);
  }, true);

  window.addEventListener('resize', syncOpenState, { passive: true });
  window.addEventListener('orientationchange', syncOpenState, { passive: true });
  document.addEventListener('DOMContentLoaded', syncOpenState);
})();
};

window.GGG_deferSectionInit('.ultimate-section', window.GGG_initUltimateSection, {
  name: 'ultimate edition section',
  rootMargin: '0px 0px',
  fallbackDelay: 2500
});


/* ===== extracted script block 19 ===== */
(function() {
  var track = document.getElementById('final-bg-track');
  if (!track || track.dataset.loaded === '1') return;
  track.dataset.loaded = '1';
  var images = [
    assetUrl("final_carousel_001.webp"),
    assetUrl("final_carousel_002.webp"),
    assetUrl("final_carousel_003.webp"),
    assetUrl("final_carousel_004.webp"),
    assetUrl("final_carousel_005.webp"),
    assetUrl("final_carousel_006.webp"),
    assetUrl("final_carousel_007.webp"),
    assetUrl("final_carousel_008.webp"),
    assetUrl("final_carousel_009.webp"),
    assetUrl("final_carousel_010.webp"),
    assetUrl("final_carousel_011.webp"),
    assetUrl("final_carousel_012.webp"),
    assetUrl("final_carousel_013.webp"),
    assetUrl("final_carousel_014.webp"),
    assetUrl("final_carousel_015.webp"),
    assetUrl("final_carousel_016.webp"),
    assetUrl("final_carousel_017.webp"),
    assetUrl("final_carousel_018.webp"),
    assetUrl("final_carousel_019.webp"),
    assetUrl("final_carousel_020.webp"),
    assetUrl("final_carousel_021.webp"),
    assetUrl("final_carousel_022.webp"),
    assetUrl("final_carousel_023.webp"),
    assetUrl("final_carousel_024.webp"),
    assetUrl("final_carousel_025.webp"),
    assetUrl("final_carousel_026.webp"),
    assetUrl("final_carousel_027.webp"),
    assetUrl("final_carousel_028.webp"),
    assetUrl("final_carousel_029.webp"),
    assetUrl("final_carousel_030.webp"),
    assetUrl("final_carousel_031.webp"),
    assetUrl("final_carousel_032.webp"),
    assetUrl("final_carousel_033.webp"),
    assetUrl("final_carousel_034.webp"),
    assetUrl("final_carousel_035.webp"),
    assetUrl("final_carousel_036.webp")
  ];
  function build(items) {
    items.forEach(function(src) {
      var item = document.createElement('div');
      item.className = 'final-bg-item';
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      item.appendChild(img);
      track.appendChild(item);
    });
  }
  build(images);
  build(images);
})();


/* Under 500px: move featured CTAs to the opposite side without affecting cards/text */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 499px)') : null;

  var items = [
    {
      buttonSelector: '#splitHero .slide-out-left .so-cta',
      slideSelector: '#splitHero .slide-out-left',
      side: 'left'
    },
    {
      buttonSelector: '#splitHero .slide-out-right .shadow-cta',
      slideSelector: '#splitHero .slide-out-right',
      side: 'right'
    }
  ];

  function setImportant(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  function clearInline(el) {
    [
      'position',
      'left',
      'right',
      'top',
      'bottom',
      'z-index',
      'display',
      'align-items',
      'justify-content',
      'width',
      'max-width',
      'min-width',
      'font-size',
      'padding',
      'box-shadow',
      'line-height',
      'white-space',
      'transform',
      'opacity',
      'visibility'
    ].forEach(function (prop) {
      el.style.removeProperty(prop);
    });

    el.classList.remove('ggg-mobile-flipped-cta');
  }

  function moveToMobile(item) {
    var button = document.querySelector(item.buttonSelector);
    var slide = document.querySelector(item.slideSelector);

    if (!button || !slide) return;

    if (!button.dataset.gggOriginalParentSet) {
      button.dataset.gggOriginalParentSet = '1';
      button.__gggOriginalParent = button.parentNode;
      button.__gggOriginalNextSibling = button.nextSibling;
    }

    if (button.parentNode !== slide) {
      slide.appendChild(button);
    }

    slide.style.setProperty('position', 'relative', 'important');
    slide.style.setProperty('overflow', 'hidden', 'important');

    button.classList.add('ggg-mobile-flipped-cta');

    setImportant(button, 'position', 'absolute');
    setImportant(button, 'top', 'auto');
    setImportant(button, 'bottom', '14px');
    setImportant(button, 'z-index', '9999');

    if (item.side === 'left') {
      setImportant(button, 'left', '10px');
      setImportant(button, 'right', 'auto');
    } else {
      setImportant(button, 'right', '10px');
      setImportant(button, 'left', 'auto');
    }

    setImportant(button, 'display', 'inline-flex');
    setImportant(button, 'align-items', 'center');
    setImportant(button, 'justify-content', 'center');

    setImportant(button, 'width', 'auto');
    setImportant(button, 'max-width', 'calc(100vw - 20px)');
    setImportant(button, 'min-width', '0');

    setImportant(button, 'font-size', '0.86rem');
    setImportant(button, 'padding', '0.72rem 1.08rem');
    setImportant(button, 'box-shadow', '0 4px 8px rgba(0,0,0,0.55), 0 10px 24px rgba(0,0,0,0.75), 0 0 0 1px rgba(0,0,0,0.18)');
    setImportant(button, 'line-height', '1');
    setImportant(button, 'white-space', 'nowrap');

    setImportant(button, 'transform', 'none');
    setImportant(button, 'opacity', '1');
    setImportant(button, 'visibility', 'visible');
  }

  function restoreDesktop(item) {
  var button = document.querySelector(item.buttonSelector);
  var slide = document.querySelector(item.slideSelector);

  if (button && button.__gggOriginalParent) {
    button.__gggOriginalParent.insertBefore(
      button,
      button.__gggOriginalNextSibling || null
    );
  }

  if (button) clearInline(button);

  /*
    Critical desktop restore:
    moveToMobile() adds these inline styles to the slide panel itself.
    If they remain after returning to desktop, the slide-out becomes
    position:relative, collapses to height:0, and stops opening.
  */
  if (slide) {
    slide.style.removeProperty('position');
    slide.style.removeProperty('overflow');
  }
}

  function update() {
    var isMobile = !mq || mq.matches;

    items.forEach(function (item) {
      if (isMobile) {
        moveToMobile(item);
      } else {
        restoreDesktop(item);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('orientationchange', update, { passive: true });

  if (mq && mq.addEventListener) {
    mq.addEventListener('change', update);
  }

  setTimeout(update, 100);
  setTimeout(update, 500);
})();


/* Fix Ultimate Edition menu icons if emoji characters render as mojibake */
(function () {
  var iconsByName = {
    'Original Edition Deck': '&#127183;',          // 🃏
    'Shadow Edition Deck': '&#127761;',            // 🌑
    'Terror Tarot Tapestry': '&#128444;&#65039;',  // 🖼️
    'Terror Tarot Sticker Pack': '&#10022;',       // ✦
    'Shadow Edition Sticker Pack': '&#10022;',     // ✦
    'Magnetic Keepsake Gift Box': '&#128230;',     // 📦
    'Digital Guidebook': '&#128214;',              // 📖
    'Guidebook — Shadow Edition': '&#128214;',     // 📖
    'Ultimate Wallpaper Collection': '&#128241;',  // 📱
    'Gothic Reading Cloth': '&#129507;',           // 🧣
    'Terror Tarot Enamel Pins': '&#128204;',       // 📌
    'Signed Art Print': '&#128444;&#65039;'        // 🖼️
  };

  function cleanText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function setIcon(el, html) {
    if (!el || !html) return;
    if (el.dataset.gggIconHtml === html) return;

    el.innerHTML = html;
    el.dataset.gggIconHtml = html;
  }

  function updateMainGridIcons() {
    document.querySelectorAll('.ult-item-card').forEach(function (card) {
      var nameEl = card.querySelector('.ult-item-name');
      var iconEl = card.querySelector('.ult-item-thumb > span');
      var icon = iconsByName[cleanText(nameEl && nameEl.textContent)];

      setIcon(iconEl, icon);
    });
  }

  function updateMiniGridIcons() {
  document.querySelectorAll('.ult-mini-cell').forEach(function (cell) {
    var thumb = cell.querySelector('.ult-mini-thumb');

    // If this cell has an image, never inject an icon.
    if (thumb && thumb.querySelector('img')) return;

    var nameEl = cell.querySelector('.ult-mini-name');
    var iconEl = thumb ? thumb.querySelector('.ult-mini-icon') : null;
    var icon = iconsByName[cleanText(nameEl && nameEl.textContent)];

    setIcon(iconEl, icon);
  });
}

  function updateDetailCarouselIcons() {
    var activeName =
      cleanText(document.getElementById('ult-d-name') && document.getElementById('ult-d-name').textContent) ||
      cleanText(document.getElementById('ult-d-header-name') && document.getElementById('ult-d-header-name').textContent);

    var icon = iconsByName[activeName];
    if (!icon) return;

    document.querySelectorAll('.ult-carousel-slide > span:first-child').forEach(function (iconEl) {
      setIcon(iconEl, icon);
    });
  }

  function updateUltimateIcons() {
    updateMainGridIcons();
    updateMiniGridIcons();
    updateDetailCarouselIcons();
  }

  var raf = 0;

  function scheduleUpdate() {
    if (raf) return;

    raf = window.requestAnimationFrame(function () {
      raf = 0;
      updateUltimateIcons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
  } else {
    scheduleUpdate();
  }

  window.addEventListener('load', scheduleUpdate);

  document.addEventListener('click', function () {
    window.setTimeout(scheduleUpdate, 0);
    window.setTimeout(scheduleUpdate, 250);
  }, true);

  if (window.MutationObserver) {
    var target = document.getElementById('ult-right-panel') || document.body;

    new MutationObserver(scheduleUpdate).observe(target, {
      childList: true,
      subtree: true
    });
  }

  window.setTimeout(scheduleUpdate, 100);
  window.setTimeout(scheduleUpdate, 500);
})();

/* Floating card preview prompt: breathing glow + dismissible "Tap to reveal" pill */
(function () {
  var STORAGE_PREFIX = 'ggg-card-preview-revealed:';

  /*
    Generic support:
    - Any element with .card-preview gets enhanced.
    Site-specific support:
    - Existing .so-cards and .shadow-cards are also treated as previews.
  */
  var PREVIEW_SELECTOR = '.card-preview, #splitHero .so-cards, #splitHero .shadow-cards';

  function previewId(preview, index) {
    if (preview.dataset.cardPreviewId) return preview.dataset.cardPreviewId;

    if (preview.matches('.so-cards')) return 'original-floating-stack';
    if (preview.matches('.shadow-cards')) return 'shadow-floating-stack';

    return 'card-preview-' + index;
  }

  function storageKey(id) {
    return STORAGE_PREFIX + id;
  }

  function wasRevealed(id) {
    try {
      return window.sessionStorage.getItem(storageKey(id)) === '1';
    } catch (error) {
      return false;
    }
  }

  function markRevealed(id) {
    try {
      window.sessionStorage.setItem(storageKey(id), '1');
    } catch (error) {}
  }

  function makeHintButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'card-preview__hint';
    button.setAttribute('aria-label', window.ggT('Tap to reveal cards'));
    button.textContent = window.ggT('Tap to reveal');
    return button;
  }

  function dismiss(preview) {
    if (!preview || preview.classList.contains('is-revealed')) return;

    preview.classList.add('is-revealed');

    if (preview.dataset.cardPreviewId) {
      markRevealed(preview.dataset.cardPreviewId);
    }
  }

  function setupPreview(preview, index) {
    if (!preview || preview.dataset.gggCardPreviewReady === '1') return;

    var id = previewId(preview, index);
    preview.dataset.cardPreviewId = id;
    preview.dataset.gggCardPreviewReady = '1';

    preview.classList.add('card-preview');
    preview.classList.add('card-preview-has-hint');

    /*
      Accessibility:
      If the card preview itself does not already have button semantics,
      add them. This does not override an existing role/tabindex.
    */
    if (!preview.hasAttribute('role')) {
      preview.setAttribute('role', 'button');
    }

    if (!preview.hasAttribute('tabindex')) {
      preview.setAttribute('tabindex', '0');
    }

    var hint = preview.querySelector(':scope > .card-preview__hint');

    if (!hint) {
      hint = makeHintButton();
      preview.appendChild(hint);
    }

    if (wasRevealed(id)) {
      preview.classList.add('is-revealed');
    }

    /*
      Use capture so the dismissal happens before existing card handlers.
      Do not call preventDefault() or stopPropagation().
      This preserves the current tap/click behavior.
    */
    preview.addEventListener('ggg:card-reveal-start', function () {
      dismiss(preview);
    });
    preview.addEventListener('click', function () {
      if (preview.dataset.ggg23CardStackReady !== '1') dismiss(preview);
    }, true);

    /*
      Button keyboard behavior already fires click on Enter/Space.
      This extra handler covers keyboard activation when focus is on the
      card-preview container itself.
    */
    preview.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (preview.dataset.ggg23CardStackReady === '1') return;

      dismiss(preview);

      /*
        Do not stop propagation. If your existing card stack key handler
        listens for Enter/Space, it can still run.
      */
    }, true);
  }

  function initCardPreviewPrompts() {
    document.querySelectorAll(PREVIEW_SELECTOR).forEach(setupPreview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardPreviewPrompts);
  } else {
    initCardPreviewPrompts();
  }

  window.addEventListener('load', initCardPreviewPrompts);

  /*
    Handles dynamic rebuilds, if any card stacks are regenerated later.
  */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      // Decorative particles and unrelated app DOM must not rescan all previews.
      var addedPreview = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(PREVIEW_SELECTOR) || node.querySelector(PREVIEW_SELECTOR));
        });
      });
      if (addedPreview) initCardPreviewPrompts();
    }).observe(document.getElementById('ggg-terror-tarot-homepage') || document.body, {
      childList: true,
      subtree: true
    });
  }
})();
/* Tap to reveal should reset on a standard refresh, but shrink after first tap during the current page view. */
(function () {
  var keys = [
    'ggg-card-preview-revealed:original-floating-stack',
    'ggg-card-preview-revealed:shadow-floating-stack'
  ];

  function resetTapRevealSessionState() {
    keys.forEach(function (key) {
      try { window.sessionStorage.removeItem(key); } catch (error) {}
    });

    document.querySelectorAll('#splitHero .so-cards.is-revealed, #splitHero .shadow-cards.is-revealed').forEach(function (stack) {
      stack.classList.remove('is-revealed');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetTapRevealSessionState);
  } else {
    resetTapRevealSessionState();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    resetTapRevealSessionState();
  });
})();


/* ===== Ultimate Edition detail photo arrows visibility guard =====
   Keeps desktop photo navigation arrows visible after the detail carousel is
   rebuilt with Shopify product-reference images. */
(function () {
  var panel = document.getElementById('ult-detail-panel');
  var outer = document.getElementById('ult-carousel-outer');
  var track = document.getElementById('ult-carousel-track');
  var dots = document.getElementById('ult-c-dots');
  if (!panel || !outer || !track) return;

  function countSlides() {
    return track.querySelectorAll('.ult-carousel-slide').length;
  }

  function syncControls() {
    var total = countSlides();
    var hasMultiple = total > 1;
    var arrows = outer.querySelectorAll('.ult-c-arr');

    outer.classList.toggle('is-multiple-photos', hasMultiple);
    outer.dataset.photoCount = String(total || 0);

    if (dots) {
      dots.classList.toggle('is-hidden', !hasMultiple);
      dots.setAttribute('aria-hidden', hasMultiple ? 'false' : 'true');
    }

    arrows.forEach(function (arrow) {
      arrow.classList.toggle('is-hidden', !hasMultiple);
      arrow.disabled = !hasMultiple;
      arrow.setAttribute('aria-hidden', hasMultiple ? 'false' : 'true');

      if (hasMultiple) {
        arrow.style.setProperty('display', 'flex', 'important');
        arrow.style.setProperty('visibility', 'visible', 'important');
        arrow.style.setProperty('opacity', '1', 'important');
        arrow.style.setProperty('pointer-events', 'auto', 'important');
      } else {
        arrow.style.removeProperty('display');
        arrow.style.removeProperty('visibility');
        arrow.style.removeProperty('opacity');
        arrow.style.removeProperty('pointer-events');
      }
    });
  }

  function scheduleSync() {
    window.requestAnimationFrame(syncControls);
    window.setTimeout(syncControls, 60);
    window.setTimeout(syncControls, 240);
  }

  window.GGG_syncUltimateCarouselControls = scheduleSync;

  if (window.MutationObserver) {
    new MutationObserver(scheduleSync).observe(track, { childList: true, subtree: true });
    new MutationObserver(scheduleSync).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function () {
    window.setTimeout(scheduleSync, 0);
  }, true);

  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', scheduleSync, { passive: true });

  scheduleSync();
})();

/* ===== Ultimate Edition detail carousel square-frame lock =====
   Desktop only. Mobile keeps the original compact detail layout: image/details
   above the horizontal all-items rail. */
(function () {
  var panel = document.getElementById('ult-detail-panel');
  var outer = document.getElementById('ult-carousel-outer');
  var track = document.getElementById('ult-carousel-track');
  if (!panel || !outer || !track) return;

  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 1001px)') : null;
  var raf = null;

  function isDesktop() {
    return !desktopQuery || desktopQuery.matches;
  }

  function clearSquareLock() {
    outer.style.removeProperty('height');
    outer.style.removeProperty('max-height');
    track.style.removeProperty('height');
    track.style.removeProperty('width');

    track.querySelectorAll('.ult-carousel-slide').forEach(function (slide) {
      slide.style.removeProperty('flex');
      slide.style.removeProperty('width');
      slide.style.removeProperty('min-width');
      slide.style.removeProperty('max-width');
      slide.style.removeProperty('height');
      slide.style.removeProperty('min-height');
      slide.style.removeProperty('aspect-ratio');
    });
  }

  function applySquareLock() {
    raf = null;

    if (!panel.classList.contains('open')) return;

    if (!isDesktop()) {
      clearSquareLock();
      return;
    }

    outer.style.removeProperty('height');
    outer.style.removeProperty('max-height');

    var width = Math.round(outer.getBoundingClientRect().width);
    if (!width) return;

    outer.style.setProperty('height', width + 'px', 'important');
    outer.style.setProperty('max-height', width + 'px', 'important');

    track.style.setProperty('height', '100%', 'important');
    track.style.setProperty('width', '100%', 'important');

    track.querySelectorAll('.ult-carousel-slide').forEach(function (slide) {
      slide.style.setProperty('flex', '0 0 100%', 'important');
      slide.style.setProperty('width', '100%', 'important');
      slide.style.setProperty('min-width', '100%', 'important');
      slide.style.setProperty('max-width', '100%', 'important');
      slide.style.setProperty('height', '100%', 'important');
      slide.style.setProperty('min-height', '0', 'important');
      slide.style.setProperty('aspect-ratio', 'auto', 'important');
    });
  }

  function scheduleSquareLock() {
    if (!isDesktop()) {
      clearSquareLock();
      return;
    }

    if (raf) window.cancelAnimationFrame(raf);
    raf = window.requestAnimationFrame(applySquareLock);
    window.setTimeout(applySquareLock, 60);
    window.setTimeout(applySquareLock, 240);
  }

  window.GGG_lockUltimateCarouselSquare = scheduleSquareLock;

  if (window.MutationObserver) {
    new MutationObserver(scheduleSquareLock).observe(panel, {
      attributes: true,
      attributeFilter: ['class']
    });

    new MutationObserver(scheduleSquareLock).observe(track, {
      childList: true,
      subtree: true
    });
  }

  track.addEventListener('load', scheduleSquareLock, true);
  window.addEventListener('resize', scheduleSquareLock, { passive: true });
  window.addEventListener('orientationchange', scheduleSquareLock, { passive: true });
  document.addEventListener('click', function () {
    window.setTimeout(scheduleSquareLock, 0);
  }, true);

  if (desktopQuery && desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', scheduleSquareLock);
  }

  scheduleSquareLock();
})();
